"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[373],{

/***/ 25117:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(53512);
var icon = __webpack_require__(61217);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(71993);
__webpack_require__(24774);

const SHOPPING_CART = 'M17.4173 17.4087C17.9065 17.4087 18.3237 17.5889 18.6691 17.9495C19.0144 18.3101 19.187 18.7356 19.187 19.226C19.187 19.7163 19.0144 20.1346 18.6691 20.4808C18.3237 20.8269 17.9065 21 17.4173 21C16.9281 21 16.5036 20.8269 16.1439 20.4808C15.7842 20.1346 15.6043 19.7163 15.6043 19.226C15.6043 18.7356 15.7842 18.3101 16.1439 17.9495C16.5036 17.5889 16.9281 17.4087 17.4173 17.4087ZM3 3H5.95683L6.79856 4.77404H20.1151C20.3597 4.77404 20.5683 4.86418 20.741 5.04447C20.9137 5.22476 21 5.44471 21 5.70433C21 5.86298 20.9568 6 20.8705 6.11538L17.6763 11.9567C17.518 12.2308 17.2986 12.4543 17.018 12.6274C16.7374 12.8005 16.4317 12.887 16.1007 12.887H9.41007L8.61151 14.3582L8.56835 14.488C8.56835 14.5457 8.58993 14.5962 8.63309 14.6394C8.67626 14.6827 8.72662 14.7043 8.78417 14.7043H19.187V16.5216H8.39568C7.90647 16.5216 7.48921 16.3413 7.14388 15.9808C6.79856 15.6202 6.6259 15.1947 6.6259 14.7043C6.6259 14.4303 6.69784 14.149 6.84173 13.8606L8.05036 11.6106L4.81295 4.77404H3V3ZM8.39568 17.4087C8.88489 17.4087 9.30935 17.5889 9.66906 17.9495C10.0288 18.3101 10.2086 18.7356 10.2086 19.226C10.2086 19.7163 10.0288 20.1346 9.66906 20.4808C9.30935 20.8269 8.88489 21 8.39568 21C7.90647 21 7.48921 20.8269 7.14388 20.4808C6.79856 20.1346 6.6259 19.7163 6.6259 19.226C6.6259 18.7356 6.79856 18.3101 7.14388 17.9495C7.48921 17.5889 7.90647 17.4087 8.39568 17.4087Z';
const IconShoppingCart = lib.variant('IconShoppingCart', icon.Icon, {
    path: SHOPPING_CART,
});

exports.w = IconShoppingCart;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 56129:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": () => (/* binding */ ProductCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/product-of-the-year/hooks.ts
var hooks = __webpack_require__(78060);
// EXTERNAL MODULE: ./src/components/badges/image-badges.tsx
var image_badges = __webpack_require__(39986);
// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(47477);
// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(19247);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-tools@1.7.2/node_modules/styled-tools/dist/es/index.js + 7 modules
var es = __webpack_require__(55703);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
// EXTERNAL MODULE: ./src/components/base/styles/variables.ts
var variables = __webpack_require__(11093);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var rating = __webpack_require__(9160);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(38828);
// EXTERNAL MODULE: ./src/components/product-checkbox/index.tsx + 1 modules
var product_checkbox = __webpack_require__(8810);
;// CONCATENATED MODULE: ./src/components/product-card-oldest/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1 0 ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 50%;\n  align-self: stretch;\n  width: 100%;\n  min-height: 100%;\n  min-width: ",
        ";\n  max-width: ",
        ";\n  text-align: ",
        ";\n  border-bottom: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    padding: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      &::before {\n        ",
        ";\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n  position: relative;\n  outline: none;\n  padding: ",
        ";\n  ",
        "\n\n  ",
        "\n\n  @media (pointer: fine) {\n    &:hover::after,\n    &.focus-visible::after {\n      ",
        "\n    }\n    ",
        ":focus-within &::after {\n      ",
        "\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  left: ",
        ";\n  z-index: 2;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  box-sizing: content-box;\n  order: 0;\n  text-align: center;\n  height: ",
        ";\n  width: ",
        ";\n  margin: 0 auto 20px auto;\n  background: ",
        ";\n  border-radius: ",
        ";\n\n  img {\n    max-height: 100%;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: 55px;\n  max-width: 55px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 1rem;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    padding: 0;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: ",
        ";\n  padding: 0 ",
        ";\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 100%;\n  padding: 2px;\n  align-self: center;\n  background: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: ",
        ";\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  overflow-wrap: break-word;\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: 12px;\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 10px;\n  padding-top: 10px;\n  font-size: 13px;\n  color: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  position: relative;\n  outline: none;\n\n  @media (pointer: fine) {\n    ",
        ":hover + &::after,\n    ",
        ":focus + &::after {\n      ",
        "\n    }\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  padding: 0 1rem 1rem;\n  position: relative;\n  outline: none;\n\n  @media (pointer: fine) {\n    ",
        ":hover + &::after,\n    ",
        ":focus + &::after {\n      ",
        "\n    }\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  box-sizing: border-box;\n\n  && {\n    text-transform: none;\n  }\n\n  &:hover,\n  &:focus {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n    top: ",
        ";\n    left: ",
        ";\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  ",
        "\n  padding: 0.1rem 0.4rem;\n  font-weight: 600;\n  color: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  left: ",
        ";\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 10px;\n  max-width: 40%;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    padding: 0;\n    margin-top: ",
        ";\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 ",
        ";\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  left: 10px;\n\n  ",
        ":hover & {\n    ",
        "\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}








var Card = styled_components_browser_esm["default"].div.attrs({
    "data-test": "ProductCard"
}).withConfig({
    displayName: "Card",
    componentId: "sc-0-0"
})(_templateObject1(), base/* layout.productCardMinWidthMobile */.bK.productCardMinWidthMobile, base/* layout.productCardMaxWidth */.bK.productCardMaxWidth, (0,es/* ifProp */.fq)("textCenter", "center", "left"), function(p) {
    return p.hasDivider ? "1px solid ".concat(p.theme.lines.primary) : "none";
}, base/* media.mediumUp */.BC.mediumUp(_templateObject(), base/* layout.productCardMinWidth */.bK.productCardMinWidth));
var ProductLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ProductLink",
    componentId: "sc-0-1"
})(_templateObject4(), base/* layout.productCardPaddingSmall */.bK.productCardPaddingSmall, base/* media.mediumUp */.BC.mediumUp(_templateObject2(), base/* layout.productCardPaddingLarge */.bK.productCardPaddingLarge), function(props) {
    return props.selected && (0,styled_components_browser_esm.css)(_templateObject3(), base/* styledUtils.overlay */.au.overlay(props.theme.bg.productCompareLight));
}, base/* styledUtils.overlay */.au.overlay(), Card, base/* styledUtils.overlay */.au.overlay());
var CampaignBadge = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CampaignBadge",
    componentId: "sc-0-2"
})(_templateObject5(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ProductImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-3"
})(_templateObject6(), base/* layout.productCardImageSize */.bK.productCardImageSize, base/* layout.productCardImageSize */.bK.productCardImageSize, function(p) {
    return p.theme.colors.base200;
}, base/* layout.borderRadius */.bK.borderRadius);
var BrandLogo = styled_components_browser_esm["default"].span.withConfig({
    displayName: "BrandLogo",
    componentId: "sc-0-4"
})(_templateObject7());
var ProductDetails = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductDetails",
    componentId: "sc-0-5"
})(_templateObject9(), (0,es/* ifProp */.fq)("stretch", "1 0 auto", "0 0 auto"), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* media.mediumUp */.BC.mediumUp(_templateObject8()));
var Rating = (0,styled_components_browser_esm["default"])(rating/* default */.Z).withConfig({
    displayName: "Rating",
    componentId: "sc-0-6"
})(_templateObject10(), function(p) {
    return p.theme.colors.base0;
});
var ProductName = styled_components_browser_esm["default"].div.attrs({
    "data-test": "ProductName"
}).withConfig({
    displayName: "ProductName",
    componentId: "sc-0-7"
})(_templateObject12(), base/* media.mediumUp */.BC.mediumUp(_templateObject11(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025));
var Subtitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-8"
})(_templateObject14(), function(p) {
    return p.theme.text.tertiary;
}, (0,variables/* remCalc */.vR)(13), base/* media.mediumUp */.BC.mediumUp(_templateObject13(), (0,variables/* remCalc */.vR)(12)));
var ExtraFooter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExtraFooter",
    componentId: "sc-0-9"
})(_templateObject16(), function(p) {
    return p.theme.text.tertiary;
}, base/* media.mediumUp */.BC.mediumUp(_templateObject15()));
var Footer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Footer",
    componentId: "sc-0-10"
})(_templateObject17(), ProductLink, ProductLink, base/* styledUtils.overlay */.au.overlay());
var CategoryArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryArea",
    componentId: "sc-0-11"
})(_templateObject18(), ProductLink, ProductLink, base/* styledUtils.overlay */.au.overlay());
var CategoryLink = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "CategoryLink",
    componentId: "sc-0-12"
})(_templateObject19(), function(p) {
    return p.theme.text.callToActionHover;
});
var DiffPercentageCore = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DiffPercentageCore",
    componentId: "sc-0-13"
})(_templateObject21(), function(p) {
    return p.theme.colors.redio500;
}, base/* media.mediumUp */.BC.mediumUp(_templateObject20(), base/* layout.productCardPaddingLarge */.bK.productCardPaddingLarge, base/* layout.productCardPaddingLarge */.bK.productCardPaddingLarge), function(p) {
    return p.theme.colors.base0;
}, base/* layout.borderRadius */.bK.borderRadius);
var DiffPercentage = (0,styled_components_browser_esm["default"])(DiffPercentageCore).withConfig({
    displayName: "DiffPercentage",
    componentId: "sc-0-14"
})(_templateObject22(), base/* layout.productCardPaddingSmall */.bK.productCardPaddingSmall, base/* layout.productCardPaddingSmall */.bK.productCardPaddingSmall);
var StoreLogo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StoreLogo",
    componentId: "sc-0-15"
})(_templateObject23());
var PriceInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceInfo",
    componentId: "sc-0-16"
})(_templateObject25(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* media.mediumUp */.BC.mediumUp(_templateObject24(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025));
var Checkbox = (0,styled_components_browser_esm["default"])(product_checkbox/* ProductCheckbox */.WX).attrs(function() {
    return {
        vertical: false
    };
}).withConfig({
    displayName: "Checkbox",
    componentId: "sc-0-17"
})(_templateObject26(), Card, product_checkbox/* productCheckboxHoverStyle */.lo);

;// CONCATENATED MODULE: ./src/components/product-card-oldest/index.js
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}







var ProductCard = function(param) {
    var id = param.id, onClick = param.onClick, category = param.category, linkAttributes = param.linkAttributes, link = param.link, campaignBadge = param.campaignBadge, image = param.image, brandLogo = param.brandLogo, productCoreProps = param.productCoreProps, rating = param.rating, ratingCount = param.ratingCount, ratingCountTranslation = param.ratingCountTranslation, name = param.name, highlightedName = param.highlightedName, subtitle = param.subtitle, price = param.price, diffPercentage = param.diffPercentage, isCampaignItem = param.isCampaignItem, hasDivider = param.hasDivider, store = param.store, className = param.className, children = param.children, footer = param.footer, selectable = param.selectable, selected = param.selected, onSelect = param.onSelect, onDeselect = param.onDeselect, externalLink = param.externalLink, onCategoryLinkClick = param.onCategoryLinkClick;
    var onToggle = selected ? onDeselect : onSelect;
    var clickHandler = (0,react.useCallback)(function(e) {
        if (selectable) {
            e.preventDefault();
            onToggle();
            return;
        }
        if (externalLink) {
            e.preventDefault();
            window.location.href = e.currentTarget.href;
        }
        onClick(e);
    }, [
        selectable,
        onToggle,
        externalLink,
        onClick
    ]);
    var productProperties = productCoreProps ? productCoreProps.map(function(p, i, arr) {
        if (p.pretty === null) return "";
        if (arr.length - 1 === i) {
            return p.pretty;
        }
        return "".concat(p.pretty, ", ");
    }) : null;
    var productOfTheYearAward = (0,hooks/* useGetProductOfTheYear */.i)(id || undefined);
    return /*#__PURE__*/ react.createElement(Card, {
        className: className,
        hasDivider: hasDivider
    }, (productOfTheYearAward === null || productOfTheYearAward === void 0 ? void 0 : productOfTheYearAward.awardLogo) && /*#__PURE__*/ react.createElement(image_badges/* GridCardImageBadge */.ni, {
        badgeUrl: productOfTheYearAward.awardLogo,
        title: "".concat(productOfTheYearAward.awardName, " ").concat(productOfTheYearAward.year)
    }), campaignBadge && /*#__PURE__*/ react.createElement(CampaignBadge, null, campaignBadge), /*#__PURE__*/ react.createElement(ProductLink, _extends({
        onClick: clickHandler
    }, linkAttributes, {
        to: link,
        "aria-label": name,
        selected: selected
    }), diffPercentage && /*#__PURE__*/ react.createElement(DiffPercentage, null, "-", Math.round(diffPercentage), "%"), image && /*#__PURE__*/ react.createElement(ProductImage, null, image, brandLogo && /*#__PURE__*/ react.createElement(BrandLogo, null, brandLogo)), /*#__PURE__*/ react.createElement(ProductDetails, {
        stretch: isCampaignItem
    }, /*#__PURE__*/ react.createElement(ProductName, null, highlightedName || name), subtitle && /*#__PURE__*/ react.createElement(Subtitle, null, subtitle), /*#__PURE__*/ react.createElement(Subtitle, null, productProperties), /*#__PURE__*/ react.createElement(Rating, {
        hide: rating === null || rating === undefined,
        rate: rating,
        centerAlign: true,
        count: ratingCount,
        countTranslation: ratingCountTranslation,
        showCounter: true,
        size: "small"
    })), /*#__PURE__*/ react.createElement(PriceInfo, null, price && /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
        value: price
    })), store && /*#__PURE__*/ react.createElement(store_logo/* StoreLogo */.Xv, {
        variant: store_logo/* StoreLogoVariant.CAMPAIGN */.mA.CAMPAIGN,
        name: store.name,
        storeId: store.id,
        featured: true,
        hasImage: store.hasLogo
    })), children && /*#__PURE__*/ react.createElement(ExtraFooter, null, children)), category && category.pathName && /*#__PURE__*/ react.createElement(CategoryArea, null, /*#__PURE__*/ react.createElement(CategoryLink, {
        size: "small",
        color: "secondary",
        variant: "outlined",
        href: category.pathName,
        truncate: true,
        onClick: function() {
            if (onCategoryLinkClick) {
                onCategoryLinkClick({
                    url: category.pathName
                });
            }
        }
    }, category.name)), footer && /*#__PURE__*/ react.createElement(Footer, null, footer), selectable && /*#__PURE__*/ react.createElement(Checkbox, {
        selected: selected,
        onSelect: onSelect,
        onDeselect: onDeselect,
        "aria-label": name
    }));
};
var func = (prop_types_default()).func, string = (prop_types_default()).string, number = (prop_types_default()).number, oneOfType = (prop_types_default()).oneOfType, arrayOf = (prop_types_default()).arrayOf, product_card_oldest_element = (prop_types_default()).element, node = (prop_types_default()).node, shape = (prop_types_default()).shape, bool = (prop_types_default()).bool;
ProductCard.propTypes = {
    onClick: func,
    link: string.isRequired,
    image: node,
    name: oneOfType([
        string.isRequired,
        node.isRequired
    ]),
    highlightedName: node,
    rating: number,
    ratingCount: number,
    ratingCountTranslation: shape({
        domain: string,
        key: string
    }),
    price: oneOfType([
        string,
        number,
        product_card_oldest_element
    ]),
    diffPercentage: number,
    isCampaignItem: bool,
    children: node,
    campaignBadge: product_card_oldest_element,
    subtitle: node,
    brandLogo: node,
    productCoreProps: arrayOf(shape({
        id: string,
        isCore: bool,
        name: string,
        pretty: string,
        prettyTable: string,
        type: string,
        unit: string,
        value: string
    })),
    linkAttributes: shape({
        target: string,
        rel: string
    }),
    category: shape({
        name: string.isRequired,
        pathName: string
    }),
    store: shape({
        name: string.isRequired,
        id: number.isRequired,
        hasLogo: bool.isRequired
    }),
    hasDivider: bool,
    className: string,
    footer: node,
    selectable: bool,
    selected: bool,
    onSelect: func,
    onDeselect: func,
    externalLink: bool,
    onCategoryLinkClick: func
};
var noop = function() {};
ProductCard.defaultProps = {
    onClick: noop,
    image: undefined,
    highlightedName: undefined,
    rating: undefined,
    ratingCount: undefined,
    ratingCountTranslation: {
        domain: "product",
        key: "product-card.n-ratings"
    },
    price: undefined,
    diffPercentage: undefined,
    isCampaignItem: false,
    children: undefined,
    campaignBadge: undefined,
    subtitle: undefined,
    brandLogo: undefined,
    productCoreProps: undefined,
    linkAttributes: undefined,
    category: undefined,
    store: undefined,
    hasDivider: false,
    className: undefined,
    footer: undefined,
    selectable: false,
    selected: false,
    onSelect: noop,
    onDeselect: noop,
    externalLink: false,
    onCategoryLinkClick: noop
};


/***/ }),

/***/ 68758:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ search)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var debounce = __webpack_require__(66292);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./src/components/search/container.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var DEFAULT_QUERY_OPTIONS = {
    groups: [
        {
            limit: 10,
            name: "categories",
            modes: [
                {
                    name: "brand_category",
                    params: {
                        fq: "row_type:category OR row_type:virtual_category OR row_type:brand_virtual_category"
                    }
                }
            ]
        },
        {
            limit: 15,
            name: "products",
            modes: [
                "product",
                "raw_sorted",
                "raw"
            ]
        },
        {
            limit: 10,
            name: "brands",
            modes: [
                "brand"
            ]
        },
        {
            limit: 10,
            name: "stores",
            modes: [
                "store"
            ]
        }
    ]
};
var SearchContainer = function(param) {
    var query = param.query, _queryOptions = param.queryOptions, queryOptions = _queryOptions === void 0 ? DEFAULT_QUERY_OPTIONS : _queryOptions, onSearchResultFound = param.onSearchResultFound, disableScrollToTop = param.disableScrollToTop, render = param.render, renderLoader = param.renderLoader;
    var ref = _slicedToArray((0,react.useState)([]), 2), results = ref[0], setResults = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(false), 2), error = ref1[0], setError = ref1[1];
    var market = (0,app_context/* useAppContext */.bp)().market;
    var selectionId = (0,react.useRef)(0);
    var retrySearch = (0,react.useRef)(-1);
    var mounted = (0,react.useRef)(false);
    var search = (0,react.useCallback)(debounce_default()(function() {
        setError(false);
        if (!market || !market.superSearchEndpoint || !market.code) {
            // eslint-disable-next-line no-console
            console.error("No superSearchEndpoint is configured in <MarketContext>");
            return;
        }
        var url = market.superSearchEndpoint;
        var body = {
            market: market.code,
            query: query,
            groups: queryOptions.groups
        };
        fetch(url, {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        }).then(function(resp) {
            if (resp.status >= 400 && resp.status < 600) {
                throw new Error(resp.message);
            }
            return resp.json();
        }).then(function(json) {
            if (json.error) {
                throw new Error("Error in search container");
            }
            var groups = json.results.map(function(group) {
                return Object.assign(group, {
                    hits: group.hits.map(function(item) {
                        selectionId.current += 1;
                        return _objectSpreadProps(_objectSpread({}, item), {
                            selectionId: "sc".concat(selectionId.current)
                        });
                    }),
                    offset: 0
                });
            });
            clearTimeout(retrySearch.current);
            if (mounted.current) {
                setResults(function(prev) {
                    return body.query === query ? groups : prev;
                });
            }
            if (!disableScrollToTop) {
                // Reset scroll position for small devices
                if ( true && window.innerWidth <= 620) {
                    window.scrollTo(0, 0);
                }
            }
        }).catch(function(e) {
            // eslint-disable-next-line no-console
            console.error(e);
            clearTimeout(retrySearch.current);
            setError(true);
            if (mounted.current) {
                // If error occurs, retry search after 1000s
                retrySearch.current = setTimeout(function() {
                    search();
                }, 1000);
            }
        });
    }, 300), [
        query,
        queryOptions,
        disableScrollToTop,
        market
    ]);
    (0,react.useEffect)(function() {
        search();
        return function() {
            search.cancel();
        };
    }, [
        search
    ]);
    (0,react.useEffect)(function() {
        onSearchResultFound === null || onSearchResultFound === void 0 ? void 0 : onSearchResultFound(results);
    }, [
        results,
        onSearchResultFound
    ]);
    (0,react.useEffect)(function() {
        mounted.current = true;
    }, []);
    if (!results.length) {
        var ref2;
        return (ref2 = renderLoader === null || renderLoader === void 0 ? void 0 : renderLoader()) !== null && ref2 !== void 0 ? ref2 : null;
    }
    if (error) {
        return null;
    }
    return render(results);
};
/* harmony default export */ const container = (SearchContainer);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(14727);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(83018);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
;// CONCATENATED MODULE: ./src/components/search/components/selectable/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n      border-radius: 5px;\n\n      > a {\n        background: none;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var SearchSelectable = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchSelectable",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return p.selected && (0,styled_components_browser_esm.css)(_templateObject(), base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(p.theme.colors.maybeBlue700, 0.2));
}, function(p) {
    return p.theme.colors.base100;
});

;// CONCATENATED MODULE: ./src/components/search/components/selectable/selectable.js



var Selectable = function(props) {
    var isSelected = String(props.selected) === String(props.id);
    return /*#__PURE__*/ react.createElement(SearchSelectable, {
        selected: isSelected,
        role: "option",
        "aria-selected": isSelected,
        "data-selected": isSelected,
        "data-query": props.query,
        "data-selection-id": props.id,
        id: "selection".concat(props.id)
    }, props.children);
};
Selectable.propTypes = {
    selected: prop_types_default().oneOfType([
        (prop_types_default()).number,
        (prop_types_default()).string
    ]),
    id: prop_types_default().oneOfType([
        (prop_types_default()).number,
        (prop_types_default()).string
    ]).isRequired,
    query: (prop_types_default()).string,
    children: (prop_types_default()).node.isRequired
};
Selectable.defaultProps = {
    selected: undefined,
    query: undefined
};
/* harmony default export */ const selectable = (Selectable);

// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(26959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/components/search/components/show-all/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n        margin-bottom: 30px;\n      "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n      margin-bottom: 20px;\n      ",
        "\n    "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n  justify-content: space-between;\n  background-color: ",
        ";\n  border-radius: 5px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var ShowAllLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ShowAllLink",
    componentId: "sc-0-0"
})(_templateObject2(), function(p) {
    return p.richText && (0,styled_components_browser_esm.css)(styles_templateObject1(), base/* media.mediumUp */.BC.mediumUp(styles_templateObject()));
}, function(p) {
    return p.theme.colors.base100;
});

;// CONCATENATED MODULE: ./src/components/search/components/show-all/show-all.js







var getQueryString = function(history) {
    return querystring.decode(history.location.search.substr(1));
};
var getLink = function(query, history) {
    var qs = getQueryString(history);
    qs.q = query;
    delete qs.search;
    var qsEncoded = querystring.encode(qs);
    return "/search?".concat(qsEncoded);
};
var ShowAll = function(param) {
    var onClick = param.onClick, styling = param.styling, query = param.query, history = param.history;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(ShowAllLink, {
        onClick: onClick,
        richText: styling === "rich",
        to: getLink(query, history)
    }, /*#__PURE__*/ react.createElement("span", null, t("search", "results.show-all-button")), /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null));
};
var string = (prop_types_default()).string, func = (prop_types_default()).func, object = (prop_types_default()).object;
ShowAll.propTypes = {
    query: string.isRequired,
    styling: string.isRequired,
    history: object.isRequired,
    onClick: func
};
ShowAll.defaultProps = {
    onClick: function() {}
};
/* harmony default export */ const show_all = (/*#__PURE__*/(0,react.memo)((0,react_router/* withRouter */.EN)(ShowAll)));

// EXTERNAL MODULE: ./src/components/product-card-oldest/index.js + 1 modules
var product_card_oldest = __webpack_require__(56129);
// EXTERNAL MODULE: ./src/components/product-row/index.tsx + 1 modules
var product_row = __webpack_require__(11037);
// EXTERNAL MODULE: ./src/components/list-item/index.tsx
var list_item = __webpack_require__(47963);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(87044);
// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(19247);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/outgoing-link/index.js
var outgoing_link = __webpack_require__(79259);
;// CONCATENATED MODULE: ./src/components/search/components/item/styles.ts
function item_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function item_styles_templateObject() {
    var data = item_styles_taggedTemplateLiteral([
        "\n  height: 24px;\n  img {\n    height: 16px;\n    width: auto;\n  }\n"
    ]);
    item_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function item_styles_templateObject1() {
    var data = item_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  .pj-ui-product-list-item--grid:hover &,\n  .pj-ui-product-row:hover & {\n    color: ",
        ";\n  }\n"
    ]);
    item_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = item_styles_taggedTemplateLiteral([
        "\n  margin-left: 5px;\n  vertical-align: -2px;\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledListItem = (0,styled_components_browser_esm["default"])(list_item/* ListItem */.H).withConfig({
    displayName: "StyledListItem",
    componentId: "sc-0-0"
})({
    "&&": {
        img: {
            marginRight: "10px"
        }
    }
});
var StoreLogo = (0,styled_components_browser_esm["default"])(store_logo/* StoreLogo */.Xv).withConfig({
    displayName: "StoreLogo",
    componentId: "sc-0-1"
})(item_styles_templateObject());
var OutlinkCallToAction = styled_components_browser_esm["default"].span.withConfig({
    displayName: "OutlinkCallToAction",
    componentId: "sc-0-2"
})(item_styles_templateObject1(), function(p) {
    return p.theme.colors.maybeBlue700;
}, function(p) {
    return p.theme.colors.maybeBlue500;
});
var OutlinkIcon = (0,styled_components_browser_esm["default"])(outgoing_link/* IconOutgoingLink */.v).withConfig({
    displayName: "OutlinkIcon",
    componentId: "sc-0-3"
})(styles_templateObject2());

;// CONCATENATED MODULE: ./src/components/search/components/item/item.js








var SearchItem = function(param) {
    var item = param.item, onClick = param.onClick, onRawClick = param.onRawClick, type = param.type, mode = param.mode, query = param.query, onSelect = param.onSelect, styling = param.styling, callToActionText = param.callToActionText, showStoreLogo = param.showStoreLogo;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, linkTo = ref.linkTo;
    var qs = {
        q: query
    };
    var externalLinkAttributes = {
        target: "_blank",
        rel: "nofollow"
    };
    var onClickHandler = function(e) {
        if (onSelect) {
            e.preventDefault();
            onSelect(item);
        }
        onClick(type, item, e);
        if (onRawClick && type === "raw") {
            onRawClick(item);
        }
    };
    var link = linkTo(type, item, qs);
    switch(type){
        case "product":
        case "raw_sorted":
            {
                if (styling === "simple") {
                    return /*#__PURE__*/ react.createElement(list_item/* ListItem */.H, {
                        name: item.name,
                        link: link,
                        onClick: onClickHandler
                    });
                }
                return mode === "row" ? /*#__PURE__*/ react.createElement(product_row/* default */.Z, {
                    onClick: onClickHandler,
                    name: item.name,
                    link: link,
                    price: item.priceRaw ? item.priceRaw : null,
                    subtitle: item.category && item.category.name,
                    image: /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                        name: item.name,
                        src: item.image
                    }),
                    rating: item.rating,
                    ratingCount: item.ratingCount,
                    storesCount: item.priceCount,
                    storesCountText: t("campaigns", "item.sold-by-n-stores", {
                        n: item.priceCount
                    }),
                    showDivider: true
                }) : /*#__PURE__*/ react.createElement(product_card_oldest/* ProductCard */.I, {
                    id: item.id,
                    onClick: onClickHandler,
                    name: item.name,
                    link: link,
                    price: item.price ? item.price : null,
                    subtitle: item.category && item.category.name,
                    image: /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                        name: item.name,
                        src: item.image
                    }),
                    rating: item.rating,
                    ratingCount: item.ratingCount
                });
            }
        case "raw":
            if (styling === "simple") {
                return /*#__PURE__*/ react.createElement(list_item/* ListItem */.H, {
                    name: item.name,
                    link: link,
                    onClick: onClickHandler,
                    linkAttributes: externalLinkAttributes
                });
            }
            return mode === "row" ? /*#__PURE__*/ react.createElement(product_row/* default */.Z, {
                onClick: onClickHandler,
                name: item.name,
                price: item.price ? item.price : null,
                link: link,
                image: /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                    name: item.name
                }),
                subtitle: /*#__PURE__*/ react.createElement(Outlink, {
                    store: item.store
                }),
                linkAttributes: externalLinkAttributes,
                showDivider: true
            }) : /*#__PURE__*/ react.createElement(product_card_oldest/* ProductCard */.I, {
                onClick: onClickHandler,
                name: item.name,
                price: item.price ? item.price : null,
                link: link,
                image: /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                    name: item.name
                }),
                subtitle: /*#__PURE__*/ react.createElement(Outlink, {
                    store: item.store
                }),
                linkAttributes: externalLinkAttributes
            });
        case "brand":
            {
                return /*#__PURE__*/ react.createElement(list_item/* ListItem */.H, {
                    name: item.name,
                    link: link,
                    onClick: onClickHandler,
                    showArrow: true
                });
            }
        case "store":
            {
                return /*#__PURE__*/ react.createElement(list_item/* ListItem */.H, {
                    name: item.name,
                    link: link,
                    onClick: onClickHandler,
                    image: showStoreLogo && item.logo && /*#__PURE__*/ react.createElement(StoreLogo, {
                        storeId: item.id,
                        name: item.name,
                        hasImage: true,
                        featured: true
                    }),
                    showArrow: true
                });
            }
        case "brand_category":
        case "brand_virtual_category":
        case "virtual_category":
        case "category":
            {
                return /*#__PURE__*/ react.createElement(StyledListItem, {
                    name: item.name,
                    link: link,
                    image: styling !== "simple" && item.logo ? /*#__PURE__*/ react.createElement("img", {
                        height: "28",
                        width: "28",
                        src: item.logo,
                        alt: ""
                    }) : null,
                    callToActionText: callToActionText,
                    showArrow: true,
                    onClick: onClickHandler
                });
            }
        default:
            return null;
    }
};
var item_object = (prop_types_default()).object, item_func = (prop_types_default()).func, oneOf = (prop_types_default()).oneOf, item_string = (prop_types_default()).string;
SearchItem.propTypes = {
    item: item_object.isRequired,
    type: oneOf([
        "product",
        "raw",
        "raw_sorted",
        "category",
        "brand_category",
        "virtual_category",
        "brand_virtual_category",
        "store",
        "brand"
    ]).isRequired,
    styling: oneOf([
        "simple",
        "rich"
    ]),
    mode: oneOf([
        "row",
        "grid"
    ]),
    onRawClick: item_func,
    onClick: item_func,
    onSelect: item_func,
    query: item_string.isRequired,
    callToActionText: item_string
};
SearchItem.defaultProps = {
    mode: "row",
    styling: "rich",
    onRawClick: function() {},
    onClick: function() {},
    onSelect: undefined,
    callToActionText: undefined
};
var Outlink = function(param) {
    var store = param.store;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement("span", null, store, " - ", /*#__PURE__*/ react.createElement(OutlinkCallToAction, null, t("search", "raw-search.go-to-shop"), /*#__PURE__*/ react.createElement(OutlinkIcon, {
        size: 14
    })));
};
Outlink.contextType = app_context/* AppContext */.Il;
Outlink.propTypes = {
    store: item_string.isRequired
};
/* harmony default export */ const item = (/*#__PURE__*/(0,react.memo)(SearchItem));

;// CONCATENATED MODULE: ./src/components/search/styles.ts
function search_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function search_styles_templateObject() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  padding: ",
        " 10px;\n"
    ]);
    search_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function search_styles_templateObject1() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  padding-top: 10px;\n"
    ]);
    search_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function search_styles_templateObject2() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n"
    ]);
    search_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n  background: white;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var NoResults = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NoResults",
    componentId: "sc-0-0"
})(search_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ShowAllSelectable = (0,styled_components_browser_esm["default"])(selectable).withConfig({
    displayName: "ShowAllSelectable",
    componentId: "sc-0-1"
})(search_styles_templateObject1());
var ProductListBox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductListBox",
    componentId: "sc-0-2"
})(search_styles_templateObject2(), function(p) {
    return p.simple ? "0" : "10px";
});
var CategoryListBox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryListBox",
    componentId: "sc-0-3"
})(_templateObject3(), function(p) {
    return p.simple ? "0" : "10px";
});
var NoResultContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NoResultContainer",
    componentId: "sc-0-4"
})(_templateObject4(), (0,base/* remCalc */.vR)(15));

;// CONCATENATED MODULE: ./src/components/search/render.js
function render_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return render_arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || render_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function render_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return render_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return render_arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}









var triggerSelection = function() {
    var a = document.querySelector('*[data-selected="true"] a');
    a.click();
};
var SearchPage = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(SearchPage, _PureComponent);
    var _super = _createSuper(SearchPage);
    function SearchPage(props) {
        _classCallCheck(this, SearchPage);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            selected: undefined
        };
        _this.spy = _this.spy.bind(_assertThisInitialized(_this));
        return _this;
    }
    _createClass(SearchPage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                window.addEventListener("keydown", this.spy);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("keydown", this.spy);
            }
        },
        {
            key: "handleEnter",
            value: function handleEnter() {
                var push = this.props.history.push;
                var activeElement = document.activeElement;
                var selected = document.querySelector('*[data-selected="true"]');
                if (selected) {
                    triggerSelection();
                } else if (activeElement && activeElement.tagName === "INPUT") {
                    var query = activeElement.value.trim();
                    if (query.length === 0) {
                        return;
                    }
                    push("/search?q=".concat(encodeURIComponent(query)));
                }
            }
        },
        {
            key: "handleSideMove",
            value: function handleSideMove() {
                var activeElement = document.activeElement;
                var push = this.props.history.push;
                if (activeElement.tagName !== "INPUT") {
                    return;
                }
                var query = this.props.query;
                var value = activeElement.value;
                if (query !== value) {
                    push("/search?q=".concat(encodeURIComponent(value)));
                }
            }
        },
        {
            key: "changeSearchInput",
            value: function changeSearchInput(selected) {
                var activeElement = document.activeElement;
                if (activeElement.tagName !== "INPUT") {
                    return;
                }
                var currentValue = this.props.query;
                if (!selected || !selected.query) {
                    activeElement.value = currentValue;
                } else {
                    var newValue = "".concat(selected.query, " ");
                    activeElement.value = newValue;
                    activeElement.setSelectionRange(currentValue.length, newValue.length);
                }
            }
        },
        {
            key: "handleKeyMove",
            value: function handleKeyMove(direction, e) {
                e.preventDefault();
                var selectable = _toConsumableArray(document.querySelectorAll("*[data-selected]")).map(function(n) {
                    return {
                        id: n.dataset.selectionId,
                        query: n.dataset.query,
                        selected: n.dataset.selected === "true"
                    };
                });
                if (selectable.length === 0) {
                    return;
                }
                var selected = selectable.findIndex(function(n) {
                    return n.selected;
                });
                var newIndex;
                if (direction === "down") {
                    newIndex = selected + 1 === selectable.length ? -1 : selected + 1;
                }
                if (direction === "up") {
                    newIndex = selected >= 0 ? selected - 1 : selectable.length - 1;
                }
                if (newIndex === -1) {
                    this.setState({
                        selected: false
                    });
                } else {
                    this.setState({
                        selected: selectable[newIndex].id
                    });
                }
                this.changeSearchInput(selectable[newIndex]);
            }
        },
        {
            key: "spy",
            value: function spy(e) {
                if (!this.props.keyboardNavigation) {
                    return;
                }
                switch(e.keyCode){
                    case 40:
                        {
                            this.handleKeyMove("down", e);
                            break;
                        }
                    case 38:
                        {
                            this.handleKeyMove("up", e);
                            break;
                        }
                    case 13:
                        {
                            this.handleEnter();
                            break;
                        }
                    case 37:
                        {
                            this.handleSideMove("left");
                            break;
                        }
                    case 39:
                        {
                            this.handleSideMove("right");
                            break;
                        }
                    default:
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, query = _props.query, onEnterSearchMenu = _props.onEnterSearchMenu, onExitSearchMenu = _props.onExitSearchMenu, onRawClick = _props.onRawClick, onItemClick = _props.onItemClick, onSelect = _props.onSelect, results = _props.results, showAllResults = _props.showAllResults, styling = _props.styling, showStoreLogo = _props.showStoreLogo;
                var t = this.context.t;
                var selected = this.state.selected;
                return /*#__PURE__*/ react.createElement("div", {
                    className: "pj-ui-search" // Shop search has dependency on this className
                    ,
                    onMouseEnter: onEnterSearchMenu,
                    onMouseLeave: onExitSearchMenu,
                    onTouchStart: onEnterSearchMenu,
                    onTouchEnd: onExitSearchMenu
                }, /*#__PURE__*/ react.createElement("div", null, styling === "rich" && showAllResults && /*#__PURE__*/ react.createElement(ShowAllSelectable, {
                    id: -1,
                    selected: selected
                }, /*#__PURE__*/ react.createElement(show_all, {
                    query: query,
                    styling: styling
                })), results.map(function(group) {
                    return /*#__PURE__*/ react.createElement("div", {
                        key: group.name
                    }, group.name === "products" && group.hits.length > 0 && /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, styling === "rich" && /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, t("search", "relevant-products.title", {
                        query: query
                    })), /*#__PURE__*/ react.createElement(ProductListBox, {
                        className: "pj-ui-search--products",
                        simple: styling === "simple",
                        role: "listbox"
                    }, group.hits.map(function(product) {
                        return /*#__PURE__*/ react.createElement(selectable, {
                            key: product.selectionId,
                            id: product.selectionId,
                            selected: selected
                        }, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(item, {
                            type: product.type,
                            item: product.item,
                            onClick: onItemClick,
                            onRawClick: onRawClick,
                            styling: styling,
                            query: query,
                            onSelect: onSelect
                        })));
                    }))), group.name === "categories" && group.hits.length > 0 && /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, styling === "rich" && /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, t("search", "relevant-categories.title", {
                        query: query
                    })), /*#__PURE__*/ react.createElement(CategoryListBox, {
                        role: "listbox",
                        className: "pj-ui-search--categories",
                        simple: styling === "simple"
                    }, group.hits.map(function(category) {
                        return /*#__PURE__*/ react.createElement(selectable, {
                            key: category.selectionId,
                            id: category.selectionId,
                            selected: selected
                        }, /*#__PURE__*/ react.createElement(item, {
                            type: category.type,
                            item: category.item,
                            styling: styling,
                            onClick: onItemClick,
                            onRawClick: onRawClick,
                            callToActionText: styling === "simple" ? t("search", "quick-search.category-call-to-action") : null,
                            mode: "row",
                            query: query,
                            onSelect: onSelect
                        }));
                    }))), group.name === "stores" && group.hits.length > 0 && /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(ProductListBox, {
                        className: "pj-ui-search--products",
                        simple: styling === "simple",
                        role: "listbox"
                    }, group.hits.map(function(store) {
                        return /*#__PURE__*/ react.createElement(selectable, {
                            key: store.selectionId,
                            id: store.selectionId,
                            selected: selected
                        }, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(item, {
                            type: store.type,
                            item: store.item,
                            onClick: onItemClick,
                            onRawClick: onRawClick,
                            styling: styling,
                            query: query,
                            onSelect: onSelect,
                            showStoreLogo: showStoreLogo
                        })));
                    }))), Boolean(!group.hits.length) && /*#__PURE__*/ react.createElement(NoResults, null, /*#__PURE__*/ react.createElement("span", null, t("search", "no-search-results.title", {
                        query: query
                    }))));
                }), styling === "simple" && showAllResults && /*#__PURE__*/ react.createElement(ShowAllSelectable, {
                    id: -1,
                    selected: selected
                }, /*#__PURE__*/ react.createElement(show_all, {
                    query: query,
                    styling: styling
                }))));
            }
        }
    ]);
    return SearchPage;
}(react.PureComponent);
SearchPage.propTypes = {
    query: (prop_types_default()).string.isRequired,
    results: (prop_types_default()).array.isRequired,
    onSelect: (prop_types_default()).func,
    onEnterSearchMenu: (prop_types_default()).func,
    onExitSearchMenu: (prop_types_default()).func,
    showAllResults: (prop_types_default()).bool,
    keyboardNavigation: (prop_types_default()).bool,
    styling: prop_types_default().oneOf([
        "simple",
        "rich"
    ]),
    onRawClick: (prop_types_default()).func,
    onItemClick: (prop_types_default()).func,
    history: (prop_types_default()).object.isRequired
};
SearchPage.defaultProps = {
    onSelect: undefined,
    onEnterSearchMenu: function() {},
    onExitSearchMenu: function() {},
    showAllResults: false,
    keyboardNavigation: false,
    styling: "rich",
    onRawClick: function() {},
    onItemClick: function() {}
};
/* harmony default export */ const render = ((0,react_router/* withRouter */.EN)(SearchPage));
SearchPage.contextType = app_context/* AppContext */.Il;

// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(56627);
;// CONCATENATED MODULE: ./src/components/search/components/loader.js
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function loader_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function loader_templateObject() {
    var data = loader_taggedTemplateLiteral([
        "\n  animation: ",
        " 0.5s ease-out 1.5s 1 normal forwards;\n  opacity: 0;\n"
    ]);
    loader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var FadeIn = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FadeIn",
    componentId: "sc-0-0"
})(loader_templateObject(), base/* animations.fadeInKeyframes */.sF.fadeInKeyframes);
var Loader = function(props) {
    return /*#__PURE__*/ react.createElement(FadeIn, null, /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, _extends({}, props)));
};
/* harmony default export */ const loader = (Loader);

;// CONCATENATED MODULE: ./src/components/search/search.js





var Search = function(param) {
    var query = param.query, options = param.options, showAllResults = param.showAllResults, keyboardNavigation = param.keyboardNavigation, onSelect = param.onSelect, styling = param.styling, onItemClick = param.onItemClick, onRawClick = param.onRawClick, onEnter = param.onEnter, onExit = param.onExit, onSearchResultFound = param.onSearchResultFound, disableScrollToTop = param.disableScrollToTop, inputMinLength = param.inputMinLength, showStoreLogo = param.showStoreLogo;
    if (query.length < inputMinLength) {
        return null;
    }
    var queryOptions = options;
    return /*#__PURE__*/ react.createElement(container, {
        query: query,
        queryOptions: queryOptions,
        disableScrollToTop: disableScrollToTop,
        onSearchResultFound: onSearchResultFound,
        renderLoader: function() {
            return /*#__PURE__*/ react.createElement(loader, {
                isActive: true
            });
        },
        render: function(results) {
            return /*#__PURE__*/ react.createElement(render, {
                showAllResults: showAllResults,
                keyboardNavigation: keyboardNavigation,
                results: results,
                query: query,
                onSelect: onSelect,
                styling: styling,
                onItemClick: onItemClick,
                onRawClick: onRawClick,
                onEnterSearchMenu: onEnter,
                onExitSearchMenu: onExit,
                showStoreLogo: showStoreLogo
            });
        }
    });
};
Search.propTypes = {
    query: (prop_types_default()).string,
    showAllResults: (prop_types_default()).bool,
    keyboardNavigation: (prop_types_default()).bool,
    options: (prop_types_default()).object,
    onSelect: (prop_types_default()).func,
    onRawClick: (prop_types_default()).func,
    onItemClick: (prop_types_default()).func,
    styling: (prop_types_default()).string,
    onEnter: (prop_types_default()).func,
    onExit: (prop_types_default()).func,
    onSearchResultFound: (prop_types_default()).func,
    disableScrollToTop: (prop_types_default()).bool,
    inputMinLength: (prop_types_default()).number,
    showStoreLogo: (prop_types_default()).bool
};
Search.defaultProps = {
    query: "",
    keyboardNavigation: true,
    showAllResults: true,
    options: {
        groups: [
            {
                limit: 3,
                name: "categories",
                modes: [
                    {
                        name: "brand_category",
                        params: {
                            fq: "row_type:category OR row_type:brand_category OR row_type:virtual_category OR row_type:brand_virtual_category"
                        }
                    }
                ]
            },
            {
                limit: 10,
                name: "products",
                modes: [
                    "product",
                    "raw_sorted",
                    "raw"
                ]
            }
        ]
    },
    onSelect: undefined,
    styling: undefined,
    onRawClick: function() {},
    onItemClick: function() {},
    onEnter: function() {},
    onExit: function() {},
    onSearchResultFound: function() {},
    disableScrollToTop: false,
    inputMinLength: 2,
    showStoreLogo: false
};
/* harmony default export */ const search = (Search);


/***/ }),

/***/ 37712:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": () => (/* binding */ expandable_group_ExpandableGroup),
  "w": () => (/* binding */ ExpandedIndicator)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/hideable/index.js
var hideable = __webpack_require__(94332);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(82698);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-down/index.js
var chevron_down = __webpack_require__(75419);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/expandable-group/styles.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      box-shadow: inset 0 -2px 0 ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  color: ",
        ";\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  padding: ",
        ";\n  text-align: left;\n  transition: background-color ",
        ";\n  width: 100%;\n\n  ",
        ";\n\n  ",
        ";\n\n  &.focus-visible {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 600;\n  font-size: ",
        ";\n  padding: 0 ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  transition: transform 0.15s ease-in-out;\n  transform: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  /* Align the badge to the right */\n  margin-left: auto;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var ExpandableGroup = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExpandableGroup",
    componentId: "sc-0-0"
})(_templateObject());
var Header = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "Header",
    componentId: "sc-0-1"
})(_templateObject3(), function(props) {
    return props.theme.text.callToAction;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.animations.buttonTransition */.bK.animations.buttonTransition, function(props) {
    return props.expanded && (0,styled_components_browser_esm.css)(_templateObject1(), props.theme.lines.groupHeader);
}, function(props) {
    return props.dark && (0,styled_components_browser_esm.css)(_templateObject2(), base/* colors.backgroundDarkGray */.O9.backgroundDarkGray);
}, function(props) {
    return base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(props.theme.colors.maybeBlue700, "0.5");
});
var Title = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Title",
    componentId: "sc-0-2"
})(_templateObject4(), base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var HeaderArrow = (0,styled_components_browser_esm["default"])(function(_param) /*#__PURE__*/ {
    var expanded = _param.expanded, props = _objectWithoutProperties(_param, [
        "expanded"
    ]);
    return react.createElement(chevron_down/* IconChevronDown */.C, _extends({}, props, {
        color: "maybeBlue700",
        size: 24
    }));
}).withConfig({
    displayName: "HeaderArrow",
    componentId: "sc-0-3"
})(_templateObject5(), function(props) {
    return props.expanded ? "scaleY(-1)" : "none";
});
var BadgeArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BadgeArea",
    componentId: "sc-0-4"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/areas/product-collection/components/expandable-group/index.tsx




var expandable_group_ExpandableGroup = function(param) {
    var children = param.children, expanded = param.expanded, title = param.title, onToggle = param.onToggle, badge = param.badge, dark = param.dark;
    return /*#__PURE__*/ react.createElement(ExpandableGroup, null, /*#__PURE__*/ react.createElement(Header, {
        expanded: expanded,
        onClick: onToggle,
        dark: dark
    }, /*#__PURE__*/ react.createElement(ExpandedIndicator, {
        expanded: expanded
    }), /*#__PURE__*/ react.createElement(Title, null, title), badge && /*#__PURE__*/ react.createElement(BadgeArea, null, badge)), /*#__PURE__*/ react.createElement(hideable.Hideable, {
        visible: expanded,
        collapse: ui/* Axis.Y */.RD.Y
    }, children));
};
var ExpandedIndicator = function(param) {
    var expanded = param.expanded;
    return /*#__PURE__*/ react.createElement(HeaderArrow, {
        expanded: expanded
    });
};


/***/ }),

/***/ 70407:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ product_compare)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var debounce = __webpack_require__(66292);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(24084);
// EXTERNAL MODULE: ./src/components/breadcrumbs/index.tsx
var breadcrumbs = __webpack_require__(45183);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(84198);
// EXTERNAL MODULE: ./src/components/product-search/index.tsx + 3 modules
var product_search = __webpack_require__(5220);
// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/areas/product-compare/actions/index.ts
var actions = __webpack_require__(73050);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(66275);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(71309);
;// CONCATENATED MODULE: ./src/areas/product-compare/components/product-finder/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      width: 100%;\n      align-items: center;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      min-width: ",
        ";\n      width: ",
        ";\n      padding-right: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n\n    ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      width: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    border-radius: 7px;\n    width: 100%;\n\n    > div {\n      width: 100%;\n    }\n\n    ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    z-index: 4;\n    margin-left: 0;\n    left: calc(-1 * ",
        ");\n    height: ",
        "px;\n    width: ",
        "px;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var headerSearchMaxwidthDesktop = "360px";
var inlineSearchMaxwidthDesktop = "326px";
var ProductFinderWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductFinderWrapper",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject2(), base/* media.mediumDown */.BC.mediumDown(_templateObject()), base/* media.largeUp */.BC.largeUp(_templateObject1(), !props.showSearchInHeader && inlineSearchMaxwidthDesktop, !props.showSearchInHeader && inlineSearchMaxwidthDesktop, !props.showSearchInHeader && "10px"));
});
var ProductFinder = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductFinder",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), base/* media.largeUp */.BC.largeUp(_templateObject3(), props.showSearchInHeader && headerSearchMaxwidthDesktop));
});
var CloseSearchButton = (0,styled_components_browser_esm["default"])(variants.OutlinedButton).withConfig({
    displayName: "CloseSearchButton",
    componentId: "sc-0-2"
})(function() {
    var size = base/* layout.searchBar.height.mobile.value */.bK.searchBar.height.mobile.value + base/* layout.searchBar.borderWidth */.bK.searchBar.borderWidth * 2;
    return (0,styled_components_browser_esm.css)(_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, size, size);
});
var CloseIcon = (0,styled_components_browser_esm["default"])(icon_close.IconClose).withConfig({
    displayName: "CloseIcon",
    componentId: "sc-0-3"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/areas/product-compare/components/product-finder/index.tsx






var product_finder_ProductFinder = function(param) {
    var onSelect = param.onSelect, focusOnMount = param.focusOnMount, relatedProducts = param.relatedProducts, showNewComparePageLayout = param.showNewComparePageLayout, showSearchInHeader = param.showSearchInHeader, toggleSearchInput = param.toggleSearchInput, _showCloseButton = param.showCloseButton, showCloseButton = _showCloseButton === void 0 ? false : _showCloseButton;
    var isDesktop = (0,react.useContext)(viewport/* ViewportContext */.R).isDesktop;
    var handleKeyDown = (0,react.useCallback)(function(e) {
        if (e.key === "Escape") {
            toggleSearchInput();
        }
    }, [
        toggleSearchInput
    ]);
    (0,react.useEffect)(function() {
        if (showSearchInHeader) {
            document.addEventListener("keydown", handleKeyDown);
        }
        return function() {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ react.createElement(ProductFinderWrapper, {
        showSearchInHeader: showSearchInHeader
    }, /*#__PURE__*/ react.createElement(ProductFinder, {
        showSearchInHeader: showSearchInHeader
    }, /*#__PURE__*/ react.createElement(product_search/* default */.Z, {
        onSelect: onSelect,
        focusOnMount: focusOnMount,
        showFloatingResult: true,
        relatedProducts: relatedProducts,
        showNewComparePageLayout: showNewComparePageLayout,
        relatedProductsAsOverlay: showSearchInHeader
    }), showCloseButton && !isDesktop && /*#__PURE__*/ react.createElement(CloseSearchButton, {
        onClick: toggleSearchInput,
        onlyIcon: true
    }, /*#__PURE__*/ react.createElement("span", {
        style: {
            display: "flex"
        }
    }, /*#__PURE__*/ react.createElement(CloseIcon, {
        size: 28
    })))));
};
var dispatchActions = {
    toggleSearchInput: actions/* toggleSearchInput */.Ie
};
/* harmony default export */ const product_finder = ((0,es/* connect */.$j)(undefined, dispatchActions)(product_finder_ProductFinder));

// EXTERNAL MODULE: ./src/areas/product-compare/tracking.ts
var tracking = __webpack_require__(85241);
;// CONCATENATED MODULE: ./src/areas/product-compare/components/buttons/toggle-search-button/index.tsx





var ToggleSearchButton = function(param) {
    var className = param.className, toggleSearchInput = param.toggleSearchInput;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(variants.OutlinedButton, {
        className: className,
        onClick: toggleSearchInput
    }, t("common", "button.add"));
};
var dispatchProps = {
    toggleSearchInput: actions/* toggleSearchInput */.Ie
};
/* harmony default export */ const toggle_search_button = ((0,es/* connect */.$j)(null, dispatchProps)(ToggleSearchButton));

;// CONCATENATED MODULE: ./src/areas/product-compare/components/page-header/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  padding: 0;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n    padding: 0;\n  "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n  display: flex;\n  flex-direction: column;\n  padding: ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n    padding: 0 ",
        ";\n  "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: 600;\n\n  ",
        "\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n      padding: 0 ",
        ";\n    "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  height: ",
        "px;\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n        display: none;\n      "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n        width: 100%;\n      "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-right: 1.5em;\n\n  &:last-child {\n    margin-right: 0;\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: ",
        ";\n  white-space: nowrap;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-weight: normal;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  margin: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}



var PageHeaderWrapper = styled_components_browser_esm["default"].header.withConfig({
    displayName: "PageHeaderWrapper",
    componentId: "sc-0-0"
})(styles_templateObject());
var PageHeaderContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PageHeaderContent",
    componentId: "sc-0-1"
})(styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(styles_templateObject1()));
var Title = styled_components_browser_esm["default"].h1.withConfig({
    displayName: "Title",
    componentId: "sc-0-2"
})(styles_templateObject4(), base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, base/* media.mediumDown */.BC.mediumDown(styles_templateObject3(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var ItemsWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ItemsWrapper",
    componentId: "sc-0-3"
})(_templateObject7(), base/* layout.searchBar.height.desktop.value */.bK.searchBar.height.desktop.value + base/* layout.searchBar.borderWidth */.bK.searchBar.borderWidth * 2, function(props) {
    return props.hasPadding && (0,styled_components_browser_esm.css)(styles_templateObject6(), base/* media.mediumDown */.BC.mediumDown(styles_templateObject5(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
});
var PageHeaderContentItem = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PageHeaderContentItem",
    componentId: "sc-0-4"
})(_templateObject12(), function(props) {
    return props.hide && (0,styled_components_browser_esm.css)(_templateObject9(), base/* media.mediumDown */.BC.mediumDown(_templateObject8()));
}, function(props) {
    return props.wide && (0,styled_components_browser_esm.css)(_templateObject11(), base/* media.mediumDown */.BC.mediumDown(_templateObject10()));
});
var styles_ToggleSearchButton = (0,styled_components_browser_esm["default"])(toggle_search_button).withConfig({
    displayName: "ToggleSearchButton",
    componentId: "sc-0-5"
})(_templateObject13(), function(props) {
    return props.hide ? "none" : "block";
});
var VersusText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "VersusText",
    componentId: "sc-0-6"
})(_templateObject14());
var BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-7"
})(_templateObject15(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product-compare/components/page-header/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}









var PageHeader = function(param) {
    var category = param.category, highlightDifferences = param.highlightDifferences, products = param.products, relatedProducts = param.relatedProducts, setHighlightDifferences = param.setHighlightDifferences, toggleSearchInput = param.toggleSearchInput, showSearchInput = param.showSearchInput, showSearchInHeader = param.showSearchInHeader;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), linkTo = ref.linkTo, t = ref.t;
    var isDesktop = (0,react.useContext)(context/* default */.ZP).isDesktop;
    var history = (0,react_router_dom/* useHistory */.k6)();
    var searchWrapper = (0,react.useRef)(null);
    var handleClickOutside = (0,react.useCallback)(function(e) {
        if (showSearchInput && searchWrapper.current && !searchWrapper.current.contains(e.target)) {
            toggleSearchInput();
        }
    }, [
        showSearchInput,
        toggleSearchInput
    ]);
    (0,react.useEffect)(function() {
        if (isDesktop) {
            document.addEventListener("click", handleClickOutside);
        }
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    });
    var showHighlightCheckbox = products.length >= 2;
    var path = [
        {
            id: "productCompare",
            name: t("category", "product-compare.breadcrumb"),
            pathName: ""
        }
    ];
    var paths = (category === null || category === void 0 ? void 0 : category.path) && Array.isArray(category.path) ? _toConsumableArray(path).concat(_toConsumableArray(category.path)).filter(function(x) {
        return x;
    }) : path;
    var onSearchSelect = (0,react.useCallback)(function(product) {
        toggleSearchInput();
        history.push(linkTo("productCompare", {
            category: category,
            products: _toConsumableArray(products).concat([
                product
            ])
        }));
        (0,tracking/* trackComparisonSelectionChanged */.GO)(products.length + 1, "add", "search");
    }, [
        category,
        history,
        linkTo,
        products,
        toggleSearchInput
    ]);
    var handleHighlightDifferences = (0,react.useCallback)(function() {
        setHighlightDifferences(!highlightDifferences);
        (0,tracking/* trackToggleShowDifferences */.fA)(!highlightDifferences);
    }, [
        highlightDifferences,
        setHighlightDifferences
    ]);
    var getTitle = function() {
        var productsInTitleLength = 2;
        if (!products.length) {
            return /*#__PURE__*/ react.createElement(Title, null, t("category", "product-compare.title-fallback"));
        }
        var title = products.length > 1 ? products.map(function(product) {
            return product.name;
        }).filter(function(name, index) {
            return index < productsInTitleLength;
        })// Reduce expects to return string but returns a JSX element.
        // Should be fixed when we have time...
        // @ts-expect-error -- see above
        .reduce(function(name1, name2) {
            var countIndicator = products.length <= productsInTitleLength ? "" : "+ ".concat(products.length - productsInTitleLength);
            return /*#__PURE__*/ react.createElement(Title, null, name1, " ", /*#__PURE__*/ react.createElement(VersusText, null, t("compare", "title.vs")), " ", name2, " ", countIndicator);
        }) : /*#__PURE__*/ react.createElement(Title, null, products[0].name);
        return title;
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(BreadCrumbWrapper, {
        "data-test": "Breadcrumbs"
    }, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        "data-test": "Breadcrumbs",
        crumbs: paths.map(function(param, index) {
            var title = param.name, href = param.pathName;
            return {
                href: paths.length - 1 !== index ? href : undefined,
                title: title
            };
        })
    })), /*#__PURE__*/ react.createElement(PageHeaderWrapper, null, /*#__PURE__*/ react.createElement(PageHeaderContent, null, getTitle(), /*#__PURE__*/ react.createElement(ItemsWrapper, {
        hasPadding: !showSearchInput
    }, showHighlightCheckbox && /*#__PURE__*/ react.createElement(PageHeaderContentItem, {
        wide: true,
        hide: showSearchInput
    }, /*#__PURE__*/ react.createElement(inputs/* Checkbox */.XZ, {
        name: "highlightDifferences",
        label: t("category", "product-compare.show-differences"),
        checked: highlightDifferences,
        onChange: handleHighlightDifferences
    })), showSearchInHeader && products.length < 12 ? /*#__PURE__*/ react.createElement(PageHeaderContentItem, {
        wide: showSearchInput,
        ref: searchWrapper
    }, showSearchInput && /*#__PURE__*/ react.createElement(product_finder, {
        focusOnMount: true,
        onSelect: onSearchSelect,
        relatedProducts: relatedProducts,
        showNewComparePageLayout: true,
        showSearchInHeader: true,
        showCloseButton: true
    }), (isDesktop || showHighlightCheckbox) && /*#__PURE__*/ react.createElement(styles_ToggleSearchButton, {
        hide: showSearchInput
    })) : null))));
};
/* harmony default export */ const page_header = (PageHeader);

// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(62372);
;// CONCATENATED MODULE: ./src/areas/product-compare/helpers/index.ts
var includes = function(array, item) {
    return array.indexOf(item) >= 0;
};

// EXTERNAL MODULE: ./src/components/base/styles/variables.ts
var variables = __webpack_require__(11093);
;// CONCATENATED MODULE: ./src/areas/product-compare/constants.ts


var compareColors = {
    highlight: base/* colors.lightTheme.yellove500 */.O9.lightTheme.yellove500,
    separator: base/* colors.lightTheme.yellove500 */.O9.lightTheme.yellove500
};
var productImageHeightDesktop = 140;
var productImageHeightMobile = 110;
var desktopMaxColumns = 4;
var imageWidthVal = 140;
var imageWidthMobileVal = 110;
var oddColumnBackgroundColor = "transparent";
var evenColumnBackgroundColor = "rgba(0, 0, 0, 0.02)";
var dummyMaxWidth = 380;
var mobileItemMaxWidth = "50vw";
var tabletItemMaxWidth = "25vw";
var productsWrapperMargin = base/* layout.measurements.spacing050 */.bK.measurements.spacing050;
var desktopItemMaxWidthVal = (base/* layout.siteWidth.value */.bK.siteWidth.value - (0,variables/* pixelCalc */.A)(productsWrapperMargin) * 2) / desktopMaxColumns;
var desktopItemMaxWidth = "".concat(desktopItemMaxWidthVal, "px");
var itemFlex = "1 1 auto";
var oddColumnHighlightColor = base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(compareColors.highlight, "0.2");
var evenColumnHighlightColor = base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(compareColors.highlight, "0.25");
var highlightDuration = base/* animations.HIGHLIGHT_NEW_CONTENT_DURATION */.sF.HIGHLIGHT_NEW_CONTENT_DURATION;
var highlightNewOddColumnAnimation = base/* animations.highlightNewContentAnimation */.sF.highlightNewContentAnimation(oddColumnBackgroundColor, oddColumnHighlightColor);
var highlightNewEvenColumnAnimation = base/* animations.highlightNewContentAnimation */.sF.highlightNewContentAnimation(evenColumnBackgroundColor, oddColumnHighlightColor);
var features = {
    useCSSScrollSnap: true
};

;// CONCATENATED MODULE: ./src/areas/product-compare/components/carousel/dots/styles.ts
function dots_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function dots_styles_templateObject() {
    var data = dots_styles_taggedTemplateLiteral([
        "\n    position: relative;\n    overflow: hidden;\n    margin: auto;\n    width: ",
        "px;\n    max-width: 100vw;\n  "
    ]);
    dots_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function dots_styles_templateObject1() {
    var data = dots_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    transform: translateX(",
        "px);\n    transition: transform 0.3s ease-out;\n  "
    ]);
    dots_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function dots_styles_templateObject2() {
    var data = dots_styles_taggedTemplateLiteral([
        "\n      background: ",
        ";\n      transform: scale(1.5, 1.5);\n    "
    ]);
    dots_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function dots_styles_templateObject3() {
    var data = dots_styles_taggedTemplateLiteral([
        "\n      transform: scale(0.5, 0.5);\n    "
    ]);
    dots_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function dots_styles_templateObject4() {
    var data = dots_styles_taggedTemplateLiteral([
        "\n    transition: transform 0.2s ease-out;\n    line-height: 0;\n    display: block;\n    background: ",
        ";\n    border-radius: 50%;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    dots_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function dots_styles_templateObject5() {
    var data = dots_styles_taggedTemplateLiteral([
        "\n    min-width: ",
        "px;\n    width: ",
        "px;\n    height: ",
        "px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    ",
        " {\n      width: ",
        "px;\n      height: ",
        "px;\n    }\n  "
    ]);
    dots_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var DotsWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DotsWrapper",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(dots_styles_templateObject(), props.width);
});
var Dots = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "Dots",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(dots_styles_templateObject1(), props.translateX);
});
var Dot = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Dot",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(dots_styles_templateObject4(), props.theme.colors.base300, props.highlighted && (0,styled_components_browser_esm.css)(dots_styles_templateObject2(), compareColors.separator), props.small && (0,styled_components_browser_esm.css)(dots_styles_templateObject3()));
});
var nTimesSmallerSize = 3;
var DotListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "DotListItem",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(dots_styles_templateObject5(), props.width, props.width, props.width, Dot, props.width / nTimesSmallerSize, props.width / nTimesSmallerSize);
});

;// CONCATENATED MODULE: ./src/areas/product-compare/components/carousel/dots/index.tsx
function dots_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function dots_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return dots_arrayLikeToArray(arr);
}
function dots_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function dots_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || dots_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function dots_toConsumableArray(arr) {
    return dots_arrayWithoutHoles(arr) || dots_iterableToArray(arr) || dots_unsupportedIterableToArray(arr) || dots_nonIterableSpread();
}
function dots_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return dots_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return dots_arrayLikeToArray(o, minLen);
}



var dots_Dots = function(param) {
    var products = param.products, totalActiveDots = param.totalActiveDots, totalVisibleDots = param.totalVisibleDots, dotWidthVal = param.dotWidthVal, positionIndexes = param.positionIndexes;
    var showSmallDots = products.length > totalVisibleDots;
    var wrappersWidth = products.length < totalVisibleDots ? products.length * dotWidthVal : totalVisibleDots * dotWidthVal;
    var ref = _slicedToArray((0,react.useState)(dots_toConsumableArray(Array(totalActiveDots)).map(function(val, index) {
        return index;
    })), 2), activeIndexes = ref[0], setActiveIndexes = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(showSmallDots ? totalVisibleDots - 1 : null), 2), smallIndexRight = ref1[0], setSmallIndexRight = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(null), 2), smallIndexLeft = ref2[0], setSmallIndexLeft = ref2[1];
    var ref3 = _slicedToArray((0,react.useState)(0), 2), dotsTranslateX = ref3[0], setDotsTranslateX = ref3[1];
    var handleLeftDirection = function() {
        // Prevents position to change past products.length
        if (includes(activeIndexes, 0)) return;
        var newActiveIndexes = activeIndexes.map(function(i) {
            return i - 1;
        });
        // Active index is the same as smallIndexRight
        if (showSmallDots && includes(newActiveIndexes, smallIndexLeft)) {
            // If active index is not at the end, move the smallIndexLeft
            if (!includes(newActiveIndexes, 0)) {
                setSmallIndexRight(smallIndexRight ? smallIndexRight - 1 : products.length - 2);
                setDotsTranslateX(dotsTranslateX + dotWidthVal);
            }
            if (includes(newActiveIndexes, 1)) {
                // Remove small right dot on second last index
                setSmallIndexLeft(null);
            } else {
                // Move small left dot backwards
                setSmallIndexLeft(smallIndexLeft ? smallIndexLeft - 1 : null);
            }
        }
        setActiveIndexes(newActiveIndexes);
    };
    var handleRightDirection = function() {
        // Prevents position to change past products.length
        if (includes(activeIndexes, products.length - 1)) return;
        var newActiveIndexes = activeIndexes.map(function(i) {
            return i + 1;
        });
        // Active index is the same as smallIndexRight
        if (showSmallDots && includes(newActiveIndexes, smallIndexRight)) {
            // If active index is not at the end, move the smallIndexLeft
            if (!includes(newActiveIndexes, products.length - 1)) {
                setSmallIndexLeft(smallIndexLeft ? smallIndexLeft + 1 : 1);
                setDotsTranslateX(dotsTranslateX - dotWidthVal);
            }
            if (includes(newActiveIndexes, products.length - 2)) {
                // Remove small right dot on second last index
                setSmallIndexRight(null);
            } else {
                // Move small right dot forwards
                setSmallIndexRight(smallIndexRight ? smallIndexRight + 1 : null);
            }
        }
        setActiveIndexes(newActiveIndexes);
    };
    // Sets direction when position indexes changes
    (0,react.useEffect)(function() {
        if (positionIndexes && JSON.stringify(activeIndexes) !== JSON.stringify(positionIndexes)) {
            var directionRight = positionIndexes[0] > activeIndexes[0];
            var jumps = directionRight ? positionIndexes[0] - activeIndexes[0] : activeIndexes[0] - positionIndexes[0];
            dots_toConsumableArray(Array(jumps)).forEach(function() {
                return directionRight ? handleRightDirection() : handleLeftDirection();
            });
        }
    });
    return /*#__PURE__*/ react.createElement(DotsWrapper, {
        width: wrappersWidth
    }, /*#__PURE__*/ react.createElement(Dots, {
        translateX: dotsTranslateX
    }, products.map(function(product, index) {
        var highlighted = includes(activeIndexes, index);
        var small = index === smallIndexRight || index === smallIndexLeft;
        return /*#__PURE__*/ react.createElement(DotListItem, {
            width: dotWidthVal,
            key: product.id
        }, /*#__PURE__*/ react.createElement(Dot, {
            highlighted: highlighted,
            small: small
        }));
    })));
};
/* harmony default export */ const dots = (dots_Dots);

// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(87044);
// EXTERNAL MODULE: ./src/components/truncated/index.tsx
var truncated = __webpack_require__(81678);
;// CONCATENATED MODULE: ./src/areas/product-compare/components/carousel/items/styles.ts
function items_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function items_styles_templateObject() {
    var data = items_styles_taggedTemplateLiteral([
        "\n  overflow: hidden;\n"
    ]);
    items_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function items_styles_templateObject1() {
    var data = items_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    transform: translateX(",
        "px);\n    transition: transform 0.3s ease-out;\n  "
    ]);
    items_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function items_styles_templateObject2() {
    var data = items_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex: 1 0 auto;\n    justify-content: center;\n    align-items: center;\n    width: ",
        "px;\n    max-height: 56px;\n    font-weight: 600;\n    padding: ",
        ";\n  "
    ]);
    items_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function items_styles_templateObject3() {
    var data = items_styles_taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    items_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function items_styles_templateObject4() {
    var data = items_styles_taggedTemplateLiteral([
        "\n  width: ",
        ";\n  height: ",
        ";\n  min-height: ",
        ";\n  min-width: ",
        ";\n  margin-right: ",
        ";\n"
    ]);
    items_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function items_styles_templateObject5() {
    var data = items_styles_taggedTemplateLiteral([
        "\n  max-height: 43px;\n"
    ]);
    items_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var productImageSize = "40px";
var Products = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Products",
    componentId: "sc-0-0"
})(items_styles_templateObject());
var InnerWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InnerWrapper",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(items_styles_templateObject1(), props.translateX);
});
var Product = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Product",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(items_styles_templateObject2(), props.width, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
});
var ProductLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ProductLink",
    componentId: "sc-0-3"
})(items_styles_templateObject3());
var ProductImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-4"
})(items_styles_templateObject4(), productImageSize, productImageSize, productImageSize, productImageSize, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ProductName = (0,styled_components_browser_esm["default"])(truncated/* Truncated */.J).withConfig({
    displayName: "ProductName",
    componentId: "sc-0-5"
})(items_styles_templateObject5());

;// CONCATENATED MODULE: ./src/areas/product-compare/components/carousel/items/index.tsx
function items_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function items_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function items_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return items_arrayLikeToArray(arr);
}
function items_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function items_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function items_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function items_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function items_slicedToArray(arr, i) {
    return items_arrayWithHoles(arr) || items_iterableToArrayLimit(arr, i) || items_unsupportedIterableToArray(arr, i) || items_nonIterableRest();
}
function items_toConsumableArray(arr) {
    return items_arrayWithoutHoles(arr) || items_iterableToArray(arr) || items_unsupportedIterableToArray(arr) || items_nonIterableSpread();
}
function items_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return items_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return items_arrayLikeToArray(o, minLen);
}






var CompareCarouselItems = function(param) {
    var columnWidth = param.columnWidth, positionIndexes = param.positionIndexes, products = param.products, totalVisibleItems = param.totalVisibleItems;
    var linkTo = (0,react.useContext)(app_context/* AppContext */.Il).linkTo;
    var ref = items_slicedToArray((0,react.useState)(items_toConsumableArray(Array(totalVisibleItems)).map(function(val, index) {
        return index;
    })), 2), activeIndexes = ref[0], setActiveIndexes = ref[1];
    var ref1 = items_slicedToArray((0,react.useState)(0), 2), imagesTranslateX = ref1[0], setImagesTranslateX = ref1[1];
    var setDirection = (0,react.useCallback)(function(isForward) {
        // Prevents position to change past products.length
        if (isForward && includes(activeIndexes, products.length - 1)) return;
        if (!isForward && includes(activeIndexes, 0)) return;
        var newActiveIndexes = activeIndexes.map(function(i) {
            return isForward ? i + 1 : i - 1;
        });
        setImagesTranslateX(isForward ? imagesTranslateX - columnWidth : imagesTranslateX + columnWidth);
        setActiveIndexes(newActiveIndexes);
    }, [
        activeIndexes,
        columnWidth,
        imagesTranslateX,
        products.length
    ]);
    // Sets direction when position indexes changes
    (0,react.useEffect)(function() {
        if (positionIndexes && JSON.stringify(activeIndexes) !== JSON.stringify(positionIndexes)) {
            var directionForward = positionIndexes[0] > activeIndexes[0];
            var jumps = directionForward ? positionIndexes[0] - activeIndexes[0] : activeIndexes[0] - positionIndexes[0];
            items_toConsumableArray(Array(jumps)).forEach(function() {
                return setDirection(directionForward);
            });
        }
    }, [
        activeIndexes,
        positionIndexes,
        setDirection
    ]);
    var renderPlaceholderProduct = function() {
        return /*#__PURE__*/ react.createElement(Product, {
            width: columnWidth
        }, /*#__PURE__*/ react.createElement(toggle_search_button, null));
    };
    return /*#__PURE__*/ react.createElement(Products, null, /*#__PURE__*/ react.createElement(InnerWrapper, {
        translateX: imagesTranslateX
    }, products.map(function(product) {
        return /*#__PURE__*/ react.createElement(Product, {
            width: columnWidth,
            key: product.id
        }, /*#__PURE__*/ react.createElement(ProductLink, {
            to: linkTo("product", product)
        }, product.media && product.media.first ? /*#__PURE__*/ react.createElement(ProductImage, null, /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
            src: product.media.first,
            name: product.name
        })) : null, /*#__PURE__*/ react.createElement(ProductName, null, product.name)));
    }), products.length === 1 && renderPlaceholderProduct()));
};
/* harmony default export */ const items = (CompareCarouselItems);

;// CONCATENATED MODULE: ./src/areas/product-compare/components/carousel/index.tsx
function carousel_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function carousel_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return carousel_arrayLikeToArray(arr);
}
function carousel_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function carousel_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function carousel_toConsumableArray(arr) {
    return carousel_arrayWithoutHoles(arr) || carousel_iterableToArray(arr) || carousel_unsupportedIterableToArray(arr) || carousel_nonIterableSpread();
}
function carousel_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return carousel_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return carousel_arrayLikeToArray(o, minLen);
}



var CompareCarousel = function(param) {
    var clientWidth = param.clientWidth, _dotWidthVal = param.dotWidthVal, dotWidthVal = _dotWidthVal === void 0 ? 15 : _dotWidthVal, products = param.products, scrollPosition = param.scrollPosition, _totalVisibleItems = param.totalVisibleItems, totalVisibleItems = _totalVisibleItems === void 0 ? 2 : _totalVisibleItems, _totalVisibleDots = param.totalVisibleDots, totalVisibleDots = _totalVisibleDots === void 0 ? 5 : _totalVisibleDots;
    var columnWidth = clientWidth / totalVisibleItems;
    var cardIndex = Math.round(scrollPosition / columnWidth);
    var activeIndexes = carousel_toConsumableArray(Array(totalVisibleItems)).map(function(val, index) {
        return cardIndex + index;
    });
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(items, {
        columnWidth: columnWidth,
        positionIndexes: activeIndexes,
        products: products,
        totalVisibleItems: totalVisibleItems
    }), products.length > 2 && /*#__PURE__*/ react.createElement(dots, {
        dotWidthVal: dotWidthVal,
        products: products,
        positionIndexes: activeIndexes,
        totalActiveDots: totalVisibleItems,
        totalVisibleDots: totalVisibleDots
    }));
};
/* harmony default export */ const carousel = (CompareCarousel);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/throttle.js
var throttle = __webpack_require__(38209);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./src/areas/product-compare/components/buttons/chevron-buttons/styles.ts
function chevron_buttons_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function chevron_buttons_styles_templateObject() {
    var data = chevron_buttons_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  top: ",
        "px;\n"
    ]);
    chevron_buttons_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function chevron_buttons_styles_templateObject1() {
    var data = chevron_buttons_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        "px;\n  z-index: 3;\n  pointer-events: none;\n  width: 100%;\n\n  @supports (position: sticky) {\n    position: sticky;\n  }\n"
    ]);
    chevron_buttons_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function chevron_buttons_styles_templateObject2() {
    var data = chevron_buttons_styles_taggedTemplateLiteral([
        "\n      opacity: 0;\n    "
    ]);
    chevron_buttons_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function chevron_buttons_styles_templateObject3() {
    var data = chevron_buttons_styles_taggedTemplateLiteral([
        "\n      left: ",
        ";\n      margin-left: ",
        ";\n    "
    ]);
    chevron_buttons_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function chevron_buttons_styles_templateObject4() {
    var data = chevron_buttons_styles_taggedTemplateLiteral([
        "\n      right: ",
        ";\n      margin-right: ",
        ";\n    "
    ]);
    chevron_buttons_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function chevron_buttons_styles_templateObject5() {
    var data = chevron_buttons_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  background-color: ",
        ";\n  color: ",
        ";\n  pointer-events: all;\n  opacity: 1;\n  transition: opacity 0.2s;\n  transform: translateY(-100%);\n  border-radius: 100%;\n\n  && {\n    svg {\n      path {\n        fill: ",
        ";\n      }\n    }\n  }\n\n  &&:hover,\n  &&:focus {\n    background: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ",
        "\n"
    ]);
    chevron_buttons_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var padding = "10px";
var buttonsTopVal = productImageHeightDesktop;
var ButtonsWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ButtonsWrapper",
    componentId: "sc-0-0"
})(chevron_buttons_styles_templateObject(), buttonsTopVal);
var ChevronButtons = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ChevronButtons",
    componentId: "sc-0-1"
})(chevron_buttons_styles_templateObject1(), buttonsTopVal);
var Button = (0,styled_components_browser_esm["default"])(variants.IconButton).withConfig({
    displayName: "Button",
    componentId: "sc-0-2"
})(chevron_buttons_styles_templateObject5(), function(p) {
    return p.theme.buttons.panning.bg;
}, function(p) {
    return p.theme.buttons.panning.text;
}, function(p) {
    return p.theme.buttons.panning.text;
}, function(p) {
    return p.theme.buttons.panning.bgHover;
}, function(props) {
    return props.hidden && (0,styled_components_browser_esm.css)(chevron_buttons_styles_templateObject2());
}, function(props) {
    return props.left && (0,styled_components_browser_esm.css)(chevron_buttons_styles_templateObject3(), padding, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
}, function(props) {
    return props.right && (0,styled_components_browser_esm.css)(chevron_buttons_styles_templateObject4(), padding, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(91661);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(98841);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(26959);
;// CONCATENATED MODULE: ./src/areas/product-compare/components/buttons/chevron-buttons/index.tsx






var chevron_buttons_ChevronButtons = function(param) {
    var _position = param.position, position = _position === void 0 ? 0 : _position, contentRef = param.contentRef, setPosition = param.setPosition;
    var SCROLL_AMOUNT = desktopItemMaxWidthVal;
    var scroll = (0,react.useCallback)(function(amount) {
        if (!contentRef.current) {
            return;
        }
        var newPosition = position + amount;
        contentRef.current.scrollTo({
            left: newPosition,
            behavior: "smooth"
        });
        setPosition(newPosition);
    }, [
        contentRef,
        position,
        setPosition
    ]);
    var handleBackButtonClick = (0,react.useCallback)(function() {
        return scroll(-SCROLL_AMOUNT);
    }, [
        scroll,
        SCROLL_AMOUNT
    ]);
    var handleForwardButtonClick = (0,react.useCallback)(function() {
        return scroll(SCROLL_AMOUNT);
    }, [
        scroll,
        SCROLL_AMOUNT
    ]);
    return /*#__PURE__*/ react.createElement(ButtonsWrapper, null, /*#__PURE__*/ react.createElement(ChevronButtons, null, /*#__PURE__*/ react.createElement(Button, {
        hidden: !contentRef.current || position === 0,
        onClick: handleBackButtonClick,
        tabIndex: 0,
        left: true,
        size: ui_button.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(chevron_left.IconChevronLeft, null)), /*#__PURE__*/ react.createElement(Button, {
        hidden: !contentRef.current || position === contentRef.current.scrollWidth - contentRef.current.clientWidth,
        onClick: handleForwardButtonClick,
        tabIndex: 0,
        right: true,
        size: ui_button.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null))));
};
/* harmony default export */ const chevron_buttons = (chevron_buttons_ChevronButtons);

// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(49763);
;// CONCATENATED MODULE: ./src/areas/product-compare/components/placeholder/types.ts
var Direction;
(function(Direction) {
    Direction["ROW"] = "ROW";
    Direction["COLUMN"] = "COLUMN";
})(Direction || (Direction = {}));

;// CONCATENATED MODULE: ./src/areas/product-compare/components/placeholder/styles.ts
function placeholder_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function placeholder_styles_templateObject() {
    var data = placeholder_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    placeholder_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function placeholder_styles_templateObject1() {
    var data = placeholder_styles_taggedTemplateLiteral([
        "\n      flex-direction: column;\n\n      ",
        " {\n        flex-direction: column;\n      }\n    "
    ]);
    placeholder_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function placeholder_styles_templateObject2() {
    var data = placeholder_styles_taggedTemplateLiteral([
        "\n  display: flex;\n\n  ",
        "\n"
    ]);
    placeholder_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function placeholder_styles_templateObject3() {
    var data = placeholder_styles_taggedTemplateLiteral([
        "\n    max-width: ",
        "px;\n    width: 100%;\n    height: ",
        "px;\n  "
    ]);
    placeholder_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function placeholder_styles_templateObject4() {
    var data = placeholder_styles_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-radius: 5px;\n  opacity: 0.25;\n\n  &:not(:first-child) {\n    margin-top: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    placeholder_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function placeholder_styles_templateObject5() {
    var data = placeholder_styles_taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  background: transparent;\n  padding: 0;\n  border-radius: 0;\n"
    ]);
    placeholder_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function placeholder_styles_templateObject6() {
    var data = placeholder_styles_taggedTemplateLiteral([
        "\n  max-width: 40px;\n  max-height: 40px;\n  mix-blend-mode: multiply;\n"
    ]);
    placeholder_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = placeholder_styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var Lines = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Lines",
    componentId: "sc-0-0"
})(placeholder_styles_templateObject());
var Placeholder = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Placeholder",
    componentId: "sc-0-1"
})(placeholder_styles_templateObject2(), function(props) {
    return props.direction === Direction.COLUMN && (0,styled_components_browser_esm.css)(placeholder_styles_templateObject1(), Lines);
});
var Item = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Item",
    componentId: "sc-0-2"
})(placeholder_styles_templateObject4(), function(p) {
    return p.theme.placeholders.fg;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return (0,styled_components_browser_esm.css)(placeholder_styles_templateObject3(), p.width, p.height);
});
var Icon = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Icon",
    componentId: "sc-0-3"
})(placeholder_styles_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Image = styled_components_browser_esm["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-4"
})(placeholder_styles_templateObject6());
var placeholder_styles_ToggleSearchButton = (0,styled_components_browser_esm["default"])(toggle_search_button).withConfig({
    displayName: "ToggleSearchButton",
    componentId: "sc-0-5"
})(styles_templateObject7(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/areas/product-compare/components/placeholder/index.tsx




var placeholder_Placeholder = function(param) {
    var _direction = param.direction, direction = _direction === void 0 ? Direction.ROW : _direction, icon = param.icon, items = param.items;
    var ref = (0,react.useContext)(context/* default */.ZP), isMobile = ref.isMobile, isTablet = ref.isTablet;
    return /*#__PURE__*/ react.createElement(Placeholder, {
        direction: direction
    }, icon && /*#__PURE__*/ react.createElement(Icon, null, /*#__PURE__*/ react.createElement(Image, {
        alt: "",
        src: icon
    })), /*#__PURE__*/ react.createElement(Lines, null, items.map(function(item, index) {
        return /*#__PURE__*/ react.createElement(react.Fragment, null, (isMobile || isTablet) && index === 1 && /*#__PURE__*/ react.createElement(placeholder_styles_ToggleSearchButton, null), /*#__PURE__*/ react.createElement(Item, {
            key: item.id,
            width: item.width,
            height: item.height
        }));
    })));
};
/* harmony default export */ const placeholder = (placeholder_Placeholder);

// EXTERNAL MODULE: ./src/components/sentiment-badge/index.js + 1 modules
var sentiment_badge = __webpack_require__(23428);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var rating = __webpack_require__(9160);
;// CONCATENATED MODULE: ./src/areas/product-compare/components/compare-products/columns/header/styles.ts
function header_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function header_styles_templateObject() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    min-width: ",
        "px;\n  "
    ]);
    header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_styles_templateObject1() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    min-width: ",
        "px;\n  "
    ]);
    header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function header_styles_templateObject2() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  padding-top: ",
        ";\n  min-width: ",
        "px;\n\n  ",
        "\n\n  ",
        ";\n"
    ]);
    header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function header_styles_templateObject3() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  content: '';\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n"
    ]);
    header_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function header_styles_templateObject4() {
    var data = header_styles_taggedTemplateLiteral([
        "\n      scroll-snap-align: start;\n    "
    ]);
    header_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function header_styles_templateObject5() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    width: ",
        ";\n  "
    ]);
    header_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function header_styles_templateObject6() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    width: ",
        ";\n  "
    ]);
    header_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function header_styles_templateObject7() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    width: ",
        ";\n  "
    ]);
    header_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    ",
        ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n    flex: 1 1 0%;\n\n    ",
        "\n\n    &:nth-child(odd)::after {\n      ",
        ";\n      background-color: ",
        ";\n      ",
        "\n    }\n\n    &:nth-child(even)::after {\n      ",
        ";\n      background-color: ",
        ";\n      ",
        "\n    }\n\n    ",
        "\n\n    ",
        "\n\n  ",
        "\n  "
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = header_styles_taggedTemplateLiteral([
        "\n      max-width: ",
        "px;\n    "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    max-width: 100%;\n  "
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  ",
        ";\n  flex: 1 1 0%;\n\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  "
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  font-weight: 600;\n  text-align: center;\n  font-size: ",
        ";\n  height: ",
        "px;\n  margin-bottom: ",
        ";\n  overflow: hidden;\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-weight: 600;\n  text-align: center;\n  font-size: ",
        ";\n  margin-bottom: 0;\n"
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = header_styles_taggedTemplateLiteral([
        "\n      display: none;\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  min-height: 46px;\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = header_styles_taggedTemplateLiteral([
        "\n      display: none;\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  min-height: ",
        "px;\n  width: 100%;\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  justify-content: center;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 24px;\n  height: 24px;\n  color: ",
        ";\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}





var headerMinWidthDesktopVal = 216;
var headerMinWidthTabletVal = 180;
var headerMinWidthMobileVal = 140;
var headerPriceFontSize = (0,base/* remCalc */.vR)(16);
var headerTitleFontSize = (0,base/* remCalc */.vR)(15);
var titleMinHeightVal = 65;
var ratingMinHeightVal = 20;
var headerStyling = (0,styled_components_browser_esm.css)(header_styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, headerMinWidthDesktopVal, base/* media.mediumDown */.BC.mediumDown(header_styles_templateObject(), headerMinWidthTabletVal), base/* media.smallOnly */.BC.smallOnly(header_styles_templateObject1(), headerMinWidthMobileVal));
var backgroundOverlay = (0,styled_components_browser_esm.css)(header_styles_templateObject3());
var Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(styles_templateObject8(), headerStyling, props.hasScrollSnap && (0,styled_components_browser_esm.css)(header_styles_templateObject4()), backgroundOverlay, oddColumnBackgroundColor, props.shouldAnimate && highlightNewOddColumnAnimation, backgroundOverlay, evenColumnBackgroundColor, props.shouldAnimate && highlightNewEvenColumnAnimation, base/* media.smallOnly */.BC.smallOnly(header_styles_templateObject5(), mobileItemMaxWidth), base/* media.mediumOnly */.BC.mediumOnly(header_styles_templateObject6(), tabletItemMaxWidth), base/* media.largeUp */.BC.largeUp(header_styles_templateObject7(), props.desktopScaleToFit && desktopItemMaxWidth));
});
var DummyHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DummyHeader",
    componentId: "sc-0-1"
})(styles_templateObject11(), evenColumnBackgroundColor, headerStyling, function(p) {
    return p.hasMaxWidth && (0,styled_components_browser_esm.css)(styles_templateObject9(), dummyMaxWidth);
}, base/* media.smallOnly */.BC.smallOnly(styles_templateObject10()));
var styles_Image = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "Image",
    componentId: "sc-0-2"
})(styles_templateObject13(), imageWidthVal, imageWidthVal, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.smallOnly */.BC.smallOnly(styles_templateObject12(), imageWidthMobileVal, imageWidthMobileVal));
var styles_Title = styled_components_browser_esm["default"].h2.withConfig({
    displayName: "Title",
    componentId: "sc-0-3"
})(styles_templateObject14(), headerTitleFontSize, titleMinHeightVal, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Price = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "Price",
    componentId: "sc-0-4"
})(styles_templateObject15(), function(p) {
    return p.theme.colors.negative700;
}, headerPriceFontSize);
var SentimentBadge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SentimentBadge",
    componentId: "sc-0-5"
})(_templateObject17(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(props) {
    return props.hide && (0,styled_components_browser_esm.css)(_templateObject16());
});
var ShippingPrice = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShippingPrice",
    componentId: "sc-0-6"
})(_templateObject18(), function(p) {
    return p.theme.text.quaternary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var RatingWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RatingWrapper",
    componentId: "sc-0-7"
})(_templateObject20(), ratingMinHeightVal, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(props) {
    return props.hide && (0,styled_components_browser_esm.css)(_templateObject19());
});
var Rating = (0,styled_components_browser_esm["default"])(rating/* default */.Z).withConfig({
    displayName: "Rating",
    componentId: "sc-0-8"
})(_templateObject21());
var CloseButton = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "CloseButton",
    componentId: "sc-0-9"
})(_templateObject22(), function(p) {
    return p.theme.icons.tertiary;
});

;// CONCATENATED MODULE: ./src/areas/product-compare/components/compare-products/columns/header/index.tsx













var header_Header = function(param) {
    var category = param.category, isDummyHeader = param.isDummyHeader, product = param.product, products = param.products, shouldAnimate = param.shouldAnimate, onImageClick = param.onImageClick, onHeaderLinkClick = param.onHeaderLinkClick;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useContext)(app_context/* AppContext */.Il), linkTo = ref5.linkTo, t = ref5.t;
    var ref6 = (0,react.useContext)(context/* default */.ZP), isDesktop = ref6.isDesktop, isMobile = ref6.isMobile;
    var trackRemovedProduct = (0,react.useCallback)(function() {
        (0,tracking/* trackComparisonSelectionChanged */.GO)(products.length - 1, "remove", "productCard");
    }, [
        products
    ]);
    var hideSentimentBadge = function() {
        return Boolean(!products.filter(function(item) {
            return item.reviewBadges && item.reviewBadges.length;
        }).length);
    };
    var hideRatings = function() {
        return Boolean(!products.filter(function(item) {
            var ref, ref1;
            return ((ref = item.aggregatedRating) === null || ref === void 0 ? void 0 : ref.count) || ((ref1 = item.userReviewSummary) === null || ref1 === void 0 ? void 0 : ref1.count);
        }).length);
    };
    var renderImage = function() {
        return product.media && product.media.first ? /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
            src: product.media.first,
            name: product.name
        }) : null;
    };
    var renderPrice = function(priceSummary) {
        return priceSummary && priceSummary.regular ? /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
            price: priceSummary.regular
        }) : null;
    };
    var renderShippingPrice = function(priceSummary) {
        var shippingValue;
        if (!priceSummary.includeShipping) {
            shippingValue = t("product", "price.unknown-shipping");
        } else {
            shippingValue = priceSummary.includeShipping === priceSummary.regular ? t("product", "price.free-shipping") : t("product", "price.including-shipping", {
                price: /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
                    key: "currency",
                    price: priceSummary.includeShipping
                })
            });
        }
        return shippingValue;
    };
    var renderSentimentBadge = function() {
        return /*#__PURE__*/ react.createElement(SentimentBadge, {
            hide: hideSentimentBadge()
        }, product.reviewBadges && product.reviewBadges.slice(0, 1).map(function(badge) {
            return /*#__PURE__*/ react.createElement(sentiment_badge/* default */.Z, {
                badge: badge,
                key: badge.id,
                showNrOfReviewsAs: isDesktop ? "number" : undefined
            });
        }));
    };
    var renderDummyHeader = function() {
        var placeholderItems = [
            {
                id: 1,
                width: isMobile ? imageWidthMobileVal : imageWidthVal,
                height: isMobile ? imageWidthMobileVal : imageWidthVal
            },
            {
                id: 2,
                width: 190,
                height: 30
            },
            {
                id: 3,
                width: 90,
                height: 20
            },
            {
                id: 4,
                width: 190,
                height: 20
            }
        ];
        return /*#__PURE__*/ react.createElement(DummyHeader, {
            key: "header-dummy",
            hasMaxWidth: !products || products.length === 0
        }, /*#__PURE__*/ react.createElement(placeholder, {
            direction: Direction.COLUMN,
            items: placeholderItems
        }));
    };
    if (isDummyHeader) return renderDummyHeader();
    if (!products || !product) return null;
    var toProduct = linkTo("product", product);
    return /*#__PURE__*/ react.createElement(Header, {
        key: "header-".concat(product.id),
        desktopScaleToFit: products && products.length >= desktopMaxColumns,
        shouldAnimate: shouldAnimate,
        hasScrollSnap: features.useCSSScrollSnap
    }, /*#__PURE__*/ react.createElement(styles_Image, {
        to: toProduct,
        onClick: function() {
            return onImageClick === null || onImageClick === void 0 ? void 0 : onImageClick({
                url: toProduct
            });
        }
    }, renderImage()), /*#__PURE__*/ react.createElement(styles_Title, null, /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: linkTo("product", product),
        onClick: function() {
            return onHeaderLinkClick === null || onHeaderLinkClick === void 0 ? void 0 : onHeaderLinkClick({
                url: toProduct
            });
        }
    }, product.name)), /*#__PURE__*/ react.createElement(RatingWrapper, {
        hide: hideRatings()
    }, product.aggregatedRating || ((ref = product.userReviewSummary) === null || ref === void 0 ? void 0 : ref.rating) ? /*#__PURE__*/ react.createElement(Rating, {
        rate: ((ref1 = product.aggregatedRating) === null || ref1 === void 0 ? void 0 : ref1.score) || ((ref2 = product.userReviewSummary) === null || ref2 === void 0 ? void 0 : ref2.rating),
        count: ((ref3 = product.aggregatedRating) === null || ref3 === void 0 ? void 0 : ref3.count) || ((ref4 = product.userReviewSummary) === null || ref4 === void 0 ? void 0 : ref4.count),
        showRate: true,
        showCounterAs: "number",
        showCounter: isDesktop
    }) : null), renderSentimentBadge(), /*#__PURE__*/ react.createElement(Price, null, renderPrice(product.priceSummary)), /*#__PURE__*/ react.createElement(ShippingPrice, null, renderShippingPrice(product.priceSummary)), /*#__PURE__*/ react.createElement(CloseButton, {
        rel: "nofollow",
        to: linkTo("productCompare", {
            category: category,
            products: products.filter(function(param) {
                var id = param.id;
                return id !== product.id;
            })
        }),
        onClick: trackRemovedProduct
    }, /*#__PURE__*/ react.createElement(icon_close.IconClose, {
        color: "base400"
    })));
};
/* harmony default export */ const header = (header_Header);

// EXTERNAL MODULE: ./src/areas/product-collection/components/expandable-group/index.tsx + 1 modules
var expandable_group = __webpack_require__(37712);
// EXTERNAL MODULE: ./src/components/data-list/components/parseNodes.tsx
var parseNodes = __webpack_require__(45656);
// EXTERNAL MODULE: ./src/components/data-list/components/colored-icon/index.tsx + 1 modules
var colored_icon = __webpack_require__(87052);
;// CONCATENATED MODULE: ./src/areas/product-compare/utils.ts
function utils_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function utils_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return utils_arrayLikeToArray(arr);
}
function utils_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function utils_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function utils_toConsumableArray(arr) {
    return utils_arrayWithoutHoles(arr) || utils_iterableToArray(arr) || utils_unsupportedIterableToArray(arr) || utils_nonIterableSpread();
}
function utils_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return utils_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return utils_arrayLikeToArray(o, minLen);
}
var mergePropertyLists = function(propertyLists) {
    return propertyLists// combine all
    .reduce(function(result, props) {
        return result.concat(props);
    }, [])// keep unique
    .reduce(function(result, prop) {
        return result.find(function(item) {
            return item.id === prop.id;
        }) ? result : utils_toConsumableArray(result).concat([
            prop
        ]);
    }, []);
};
var getProductProps = function(product) {
    return product && product.properties && product.properties.nodes ? product.properties.nodes : [];
};
var getProductRootProps = function(product) {
    return getProductProps(product).filter(function(item) {
        return item.isRoot;
    });
};
var getProductProp = function(product, propId) {
    return getProductProps(product).find(function(item) {
        return item.id === propId;
    });
};
var getProductListProps = function(products) {
    return products ? mergePropertyLists(products.map(getProductProps)) : [];
};
var getProductListRootProps = function(products) {
    return products ? mergePropertyLists(products.map(getProductRootProps)).map(function(item) {
        return {
            id: item.id,
            name: item.name,
            children: item.children
        };
    }) : [];
};

;// CONCATENATED MODULE: ./src/areas/product-compare/components/compare-products/columns/section/styles.ts
function section_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function section_styles_templateObject() {
    var data = section_styles_taggedTemplateLiteral([
        "\n    max-width: 100%;\n  "
    ]);
    section_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function section_styles_templateObject1() {
    var data = section_styles_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n\n  ",
        ";\n"
    ]);
    section_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function section_styles_templateObject2() {
    var data = section_styles_taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    section_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function section_styles_templateObject3() {
    var data = section_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: ",
        "px;\n  margin: 0;\n  left: 0;\n  top: initial;\n  position: relative;\n"
    ]);
    section_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function section_styles_templateObject4() {
    var data = section_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 0;\n  align-items: center;\n  left: 0;\n  text-align: left;\n  font-weight: 600;\n  z-index: 2;\n  position: absolute;\n\n  @supports (position: sticky) {\n    position: sticky;\n  }\n"
    ]);
    section_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function section_styles_templateObject5() {
    var data = section_styles_taggedTemplateLiteral([
        "\n      &:after {\n        content: '';\n        display: block;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 1px;\n        background-color: ",
        ";\n      }\n    "
    ]);
    section_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function section_styles_templateObject6() {
    var data = section_styles_taggedTemplateLiteral([
        "\n      max-width: ",
        ";\n    "
    ]);
    section_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function section_styles_templateObject7() {
    var data = section_styles_taggedTemplateLiteral([
        "\n      width: ",
        ";\n    "
    ]);
    section_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function section_styles_templateObject8() {
    var data = section_styles_taggedTemplateLiteral([
        "\n      width: ",
        ";\n    "
    ]);
    section_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function section_styles_templateObject9() {
    var data = section_styles_taggedTemplateLiteral([
        "\n    ",
        ";\n    color: ",
        ";\n    cursor: pointer;\n    flex: 1 1 0%;\n\n    &:active {\n      color: ",
        ";\n    }\n\n    /** Section headers are offset by 1, so the inverse styles for even/odd columns apply */\n    &:nth-child(odd) {\n      background-color: ",
        ";\n      ",
        "\n    }\n\n    &:nth-child(even) {\n      background-color: ",
        ";\n      ",
        "\n    }\n\n    ",
        ";\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    section_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function section_styles_templateObject10() {
    var data = section_styles_taggedTemplateLiteral([
        "\n    position: absolute;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding-left: ",
        ";\n    color: ",
        ";\n    cursor: pointer;\n\n    > svg {\n      vertical-align: middle;\n      margin-right: 0.5rem;\n    }\n  "
    ]);
    section_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function section_styles_templateObject11() {
    var data = section_styles_taggedTemplateLiteral([
        "\n  flex: 0;\n  text-align: left;\n  position: absolute;\n  left: 0;\n\n  @supports (position: sticky) {\n    position: sticky;\n  }\n"
    ]);
    section_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function section_styles_templateObject12() {
    var data = section_styles_taggedTemplateLiteral([
        "\n        max-width: ",
        "px;\n      "
    ]);
    section_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function section_styles_templateObject13() {
    var data = section_styles_taggedTemplateLiteral([
        "\n      ",
        ";\n\n      ",
        ";\n    "
    ]);
    section_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function section_styles_templateObject14() {
    var data = section_styles_taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n  display: flex;\n  flex: ",
        ";\n\n  ",
        " {\n    flex: 0;\n  }\n\n  ",
        ";\n"
    ]);
    section_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function section_styles_templateObject15() {
    var data = section_styles_taggedTemplateLiteral([
        "\n      max-width: ",
        ";\n    "
    ]);
    section_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = section_styles_taggedTemplateLiteral([
        "\n      width: ",
        ";\n    "
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function styles_templateObject17() {
    var data = section_styles_taggedTemplateLiteral([
        "\n      width: ",
        ";\n    "
    ]);
    styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function styles_templateObject18() {
    var data = section_styles_taggedTemplateLiteral([
        "\n    ",
        ";\n    text-overflow: ellipsis;\n    overflow: hidden;\n    margin: 0;\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n    flex: 1 1 0%;\n\n    /** Property cells are offset by 1, so the inverse styles for even/odd columns apply */\n    &:nth-child(odd) {\n      background-color: ",
        ";\n      ",
        "\n    }\n\n    &:nth-child(even) {\n      background-color: ",
        ";\n      ",
        "\n    }\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function styles_templateObject19() {
    var data = section_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  flex: 1 1 0%;\n"
    ]);
    styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function styles_templateObject20() {
    var data = section_styles_taggedTemplateLiteral([
        "\n      max-width: ",
        "px;\n    "
    ]);
    styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function styles_templateObject21() {
    var data = section_styles_taggedTemplateLiteral([
        "\n        border-bottom: 2px solid ",
        ";\n      "
    ]);
    styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function styles_templateObject22() {
    var data = section_styles_taggedTemplateLiteral([
        "\n  display: flex;\n\n  ",
        ";\n\n  > * {\n    border-bottom: 1px solid ",
        ";\n\n    ",
        "\n  }\n\n  &:hover {\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = section_styles_taggedTemplateLiteral([
        "\n    background-color: transparent;\n    padding: 0;\n    margin: 5px ",
        ";\n    text-transform: none;\n  "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = section_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  ",
        ";\n  padding-top: ",
        ";\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = section_styles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}



var HEADER_HEIGHT = 47;
var dummyStyling = (0,styled_components_browser_esm.css)(section_styles_templateObject1(), evenColumnBackgroundColor, base/* media.smallOnly */.BC.smallOnly(section_styles_templateObject()));
var sharedPadding = (0,styled_components_browser_esm.css)(section_styles_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var sharedSectionHeaderStyles = (0,styled_components_browser_esm.css)(section_styles_templateObject3(), HEADER_HEIGHT);
var TitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TitleWrapper",
    componentId: "sc-0-0"
})(section_styles_templateObject4());
var SectionHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SectionHeader",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(section_styles_templateObject9(), sharedSectionHeaderStyles, props.theme.text.linkExternal, props.theme.colors.base700, evenColumnBackgroundColor, props.shouldAnimate && highlightNewEvenColumnAnimation, oddColumnBackgroundColor, props.shouldAnimate && highlightNewOddColumnAnimation, !props.open && (0,styled_components_browser_esm.css)(section_styles_templateObject5(), props.theme.colors.base0), base/* media.smallOnly */.BC.smallOnly(section_styles_templateObject6(), mobileItemMaxWidth), base/* media.mediumOnly */.BC.mediumOnly(section_styles_templateObject7(), tabletItemMaxWidth), base/* media.largeUp */.BC.largeUp(section_styles_templateObject8(), props.desktopScaleToFit && desktopItemMaxWidth));
});
var section_styles_Title = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Title",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(section_styles_templateObject10(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, props.theme.text.callToAction);
});
var PropertyHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PropertyHeader",
    componentId: "sc-0-3"
})(section_styles_templateObject11());
var PropertyList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PropertyList",
    componentId: "sc-0-4"
})(section_styles_templateObject14(), function(p) {
    return p.theme.lines.secondary;
}, itemFlex, PropertyHeader, function(p) {
    return p.isDummy && (0,styled_components_browser_esm.css)(section_styles_templateObject13(), dummyStyling, p.hasMaxWidth && (0,styled_components_browser_esm.css)(section_styles_templateObject12(), dummyMaxWidth));
});
var Property = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Property",
    componentId: "sc-0-5"
})(function(param) {
    var isDiff = param.isDiff, shouldAnimate = param.shouldAnimate, desktopScaleToFit = param.desktopScaleToFit;
    return (0,styled_components_browser_esm.css)(styles_templateObject18(), sharedPadding, base/* layout.measurements.spacing250 */.bK.measurements.spacing250, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, isDiff ? evenColumnHighlightColor : evenColumnBackgroundColor, shouldAnimate && !isDiff && highlightNewEvenColumnAnimation, isDiff ? oddColumnHighlightColor : oddColumnBackgroundColor, shouldAnimate && !isDiff && highlightNewOddColumnAnimation, base/* media.smallOnly */.BC.smallOnly(section_styles_templateObject15(), mobileItemMaxWidth), base/* media.mediumOnly */.BC.mediumOnly(styles_templateObject16(), tabletItemMaxWidth), base/* media.largeUp */.BC.largeUp(styles_templateObject17(), desktopScaleToFit && desktopItemMaxWidth));
});
var DummySectionHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DummySectionHeader",
    componentId: "sc-0-6"
})(styles_templateObject19(), dummyStyling, sharedSectionHeaderStyles);
var Section = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Section",
    componentId: "sc-0-7"
})(styles_templateObject22(), function(p) {
    return p.hasMaxWidth && (0,styled_components_browser_esm.css)(styles_templateObject20(), dummyMaxWidth);
}, function(p) {
    return p.theme.lines.secondary;
}, function(p) {
    return p.open && (0,styled_components_browser_esm.css)(styles_templateObject21(), compareColors.separator);
}, section_styles_Title, function(p) {
    return p.theme.text.callToActionHover;
});
var PropertyHeaderLabel = styled_components_browser_esm["default"].span.withConfig({
    displayName: "PropertyHeaderLabel",
    componentId: "sc-0-8"
})(_templateObject24(), sharedPadding, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.text.quaternary;
}, base/* media.mediumDown */.BC.mediumDown(_templateObject23(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var SectionHeaderButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "SectionHeaderButton",
    componentId: "sc-0-9"
})(_templateObject25());

;// CONCATENATED MODULE: ./src/areas/product-compare/components/compare-products/columns/section/index.tsx
function section_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function section_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function section_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function section_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function section_slicedToArray(arr, i) {
    return section_arrayWithHoles(arr) || section_iterableToArrayLimit(arr, i) || section_unsupportedIterableToArray(arr, i) || section_nonIterableRest();
}
function section_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return section_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return section_arrayLikeToArray(o, minLen);
}








var section_Section = function(param) {
    var defaultOpen = param.defaultOpen, highlightDifferences = param.highlightDifferences, isDummySection = param.isDummySection, isOpen = param.isOpen, products = param.products, properties = param.properties, title = param.title, shouldAnimate = param.shouldAnimate, sectionId = param.sectionId;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = section_slicedToArray((0,react.useState)(Boolean(defaultOpen)), 2), open = ref[0], setOpen = ref[1];
    var sectionIsOpen = isOpen !== undefined ? isOpen : open;
    var allProps = products ? getProductListProps(products) : [];
    var handleClick = (0,react.useCallback)(function() {
        setOpen(!sectionIsOpen);
    }, [
        sectionIsOpen
    ]);
    var renderPropertyValue = function(property) {
        if (!property) {
            return null;
        }
        var parsed = (0,parseNodes/* parseNodes */.E)(property, t, true);
        if (property.type === "boolean" && property.boolean !== null) {
            return property.boolean ? /*#__PURE__*/ react.createElement(colored_icon/* Yes */.sk, null) : /*#__PURE__*/ react.createElement(colored_icon.No, null);
        }
        return parsed.value.text;
    };
    var renderProperty = function(property, depth) {
        if (!property || property.type === "link") {
            return null;
        }
        var children = Array.isArray(property.children) && property.children.length ? property.children.filter(function(id) {
            return id;
        }).map(function(id) {
            return allProps.find(function(item) {
                return item.id === id;
            });
        }) : [];
        var row = /*#__PURE__*/ react.createElement(PropertyList, null, /*#__PURE__*/ react.createElement(PropertyHeader, null, /*#__PURE__*/ react.createElement(PropertyHeaderLabel, {
            depth: depth
        }, property.name)), products.map(function(p, index) {
            var productProperty = getProductProp(p, property.id);
            var value = renderPropertyValue(productProperty);
            return /*#__PURE__*/ react.createElement(react.Fragment, {
                key: "property-wrapper-".concat(p.id)
            }, /*#__PURE__*/ react.createElement(Property, {
                key: "property-".concat(p.id),
                isDiff: highlightDifferences && productProperty && productProperty.isDiff,
                desktopScaleToFit: products && products.length >= desktopMaxColumns,
                shouldAnimate: products && index + 1 === products.length && shouldAnimate
            }, value === "" && depth > 0 ? "" : value), products.length === 1 && /*#__PURE__*/ react.createElement(Property, null, " "));
        }));
        var childRows = children.length ? children.map(function(child) {
            return child && renderProperty(child, depth + 1);
        }) : null;
        return row || childRows ? /*#__PURE__*/ react.createElement(react.Fragment, {
            key: "_property_row_".concat(property.id)
        }, row, childRows) : null;
    };
    var rows = properties && properties.map(function(propertyId) {
        if (!propertyId) return undefined;
        var property = allProps && allProps.find(function(item) {
            return item.id === propertyId;
        });
        return property && renderProperty(property, 0);
    });
    var renderDummySection = function() {
        return /*#__PURE__*/ react.createElement(react.Fragment, {
            key: "dummy-section-".concat(sectionId)
        }, /*#__PURE__*/ react.createElement(Section, {
            open: true,
            hasMaxWidth: !products || products.length === 0
        }, /*#__PURE__*/ react.createElement(DummySectionHeader, null)), [
            1,
            2,
            3
        ].map(function(item) {
            return /*#__PURE__*/ react.createElement(PropertyList, {
                key: "dummy-section-".concat(item),
                isDummy: true,
                hasMaxWidth: !products || products.length === 0
            }, /*#__PURE__*/ react.createElement(PropertyHeader, null), /*#__PURE__*/ react.createElement(Property, null, " "));
        }));
    };
    return isDummySection || !products ? renderDummySection() : /*#__PURE__*/ react.createElement(react.Fragment, {
        key: "column-section-".concat(sectionId)
    }, /*#__PURE__*/ react.createElement(SectionHeaderButton, {
        type: "button",
        onClick: handleClick
    }, /*#__PURE__*/ react.createElement(Section, {
        open: open
    }, products.map(function(item, index) {
        return /*#__PURE__*/ react.createElement(react.Fragment, {
            key: "product-".concat(item.id)
        }, index === 0 && /*#__PURE__*/ react.createElement(TitleWrapper, null, /*#__PURE__*/ react.createElement(section_styles_Title, null, /*#__PURE__*/ react.createElement(expandable_group/* ExpandedIndicator */.w, {
            expanded: sectionIsOpen
        }), title)), /*#__PURE__*/ react.createElement(SectionHeader, {
            desktopScaleToFit: products.length >= desktopMaxColumns,
            shouldAnimate: index + 1 === products.length && shouldAnimate
        }));
    }), products.length === 1 && /*#__PURE__*/ react.createElement(DummySectionHeader, null))), sectionIsOpen ? rows : null);
};
/* harmony default export */ const section = (section_Section);

;// CONCATENATED MODULE: ./src/areas/product-compare/components/compare-products/columns/styles.ts
function columns_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function columns_styles_templateObject() {
    var data = columns_styles_taggedTemplateLiteral([
        "\n    margin-right: ",
        ";\n  "
    ]);
    columns_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function columns_styles_templateObject1() {
    var data = columns_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex: ",
        ";\n\n  ",
        ";\n"
    ]);
    columns_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function columns_styles_templateObject2() {
    var data = columns_styles_taggedTemplateLiteral([
        "\n  flex: ",
        ";\n  display: flex;\n"
    ]);
    columns_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Columns = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Columns",
    componentId: "sc-0-0"
})(columns_styles_templateObject1(), itemFlex, base/* media.largeUp */.BC.largeUp(columns_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var Headers = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Headers",
    componentId: "sc-0-1"
})(columns_styles_templateObject2(), itemFlex);

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking_tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/areas/product-compare/components/compare-products/columns/index.tsx










var columns_Columns = function(param) {
    var highlightDifferences = param.highlightDifferences, products = param.products, shouldAnimate = param.shouldAnimate, setAddProductAnimation = param.setAddProductAnimation;
    var market = (0,react.useContext)(app_context/* AppContext */.Il).market;
    // Reset the `shouldAnimate` state when the animation is finished
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setAddProductAnimation(false);
        }, highlightDuration);
    }, [
        shouldAnimate,
        setAddProductAnimation
    ]);
    var sections = products ? getProductListRootProps(products).sort(function(a, b) {
        if (!a.name || !b.name) return 1;
        return a.name.localeCompare(b.name, market.locale.replace("_", "-"));
    }) : [];
    var renderHeaders = function() {
        return /*#__PURE__*/ react.createElement(Headers, null, products.map(function(product, index) {
            return /*#__PURE__*/ react.createElement(header, {
                key: "column-header-".concat(product.id),
                product: product,
                products: products,
                shouldAnimate: index + 1 === products.length && shouldAnimate,
                onImageClick: function(clickData) {
                    return (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking_tracking/* InternalNavigationScope.COMPARE_PRODUCTS_PRODUCT_IMAGE */.U.COMPARE_PRODUCTS_PRODUCT_IMAGE,
                        nextPage: clickData.url,
                        index: index
                    });
                },
                onHeaderLinkClick: function(clickData) {
                    return (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking_tracking/* InternalNavigationScope.COMPARE_PRODUCTS_PRODUCT_HEADER */.U.COMPARE_PRODUCTS_PRODUCT_HEADER,
                        nextPage: clickData.url,
                        index: index
                    });
                }
            });
        }), products.length <= 1 && /*#__PURE__*/ react.createElement(header, {
            isDummyHeader: true,
            products: products
        }));
    };
    var renderSections = function() {
        return /*#__PURE__*/ react.createElement(react.Fragment, null, sections.map(function(props) {
            var id = props.id, name = props.name, children = props.children;
            return /*#__PURE__*/ react.createElement(section, {
                key: "section-".concat(id),
                sectionId: id,
                defaultOpen: true,
                highlightDifferences: highlightDifferences,
                title: name,
                products: products,
                properties: children,
                shouldAnimate: shouldAnimate
            });
        }), products.length < 1 && /*#__PURE__*/ react.createElement(section, {
            isDummySection: true,
            sectionId: "dummy-section"
        }));
    };
    return /*#__PURE__*/ react.createElement(Columns, null, renderHeaders(), renderSections());
};
var mapStateToProps = function(state) {
    return {
        shouldAnimate: state.areas.compare.shouldAnimate
    };
};
var columns_dispatchActions = {
    setAddProductAnimation: actions/* setAddProductAnimation */._6
};
/* harmony default export */ const columns = ((0,es/* connect */.$j)(mapStateToProps, columns_dispatchActions)(columns_Columns));

;// CONCATENATED MODULE: ./src/areas/product-compare/components/compare-products/styles.ts
function compare_products_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function compare_products_styles_templateObject() {
    var data = compare_products_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  position: relative;\n  min-width: 0;\n  flex: ",
        ";\n"
    ]);
    compare_products_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function compare_products_styles_templateObject1() {
    var data = compare_products_styles_taggedTemplateLiteral([
        "\n    margin: 0;\n  "
    ]);
    compare_products_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function compare_products_styles_templateObject2() {
    var data = compare_products_styles_taggedTemplateLiteral([
        "\n      overflow-x: auto;\n      overflow-y: auto;\n    "
    ]);
    compare_products_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function compare_products_styles_templateObject3() {
    var data = compare_products_styles_taggedTemplateLiteral([
        "\n      scroll-snap-type: x mandatory;\n    "
    ]);
    compare_products_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function compare_products_styles_templateObject4() {
    var data = compare_products_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: ",
        ";\n  margin: 0 ",
        ";\n  margin-bottom: ",
        ";\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    compare_products_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function compare_products_styles_templateObject5() {
    var data = compare_products_styles_taggedTemplateLiteral([
        "\n  background: rgba(0, 0, 0, 0.5);\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n"
    ]);
    compare_products_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var COLUMN_WIDTH_LARGE = 245;
var COLUMN_WIDTH_SMALL = 200;
var compareMarginBottom = "40px";
var CompareProducts = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CompareProducts",
    componentId: "sc-0-0"
})(compare_products_styles_templateObject(), itemFlex);
var ProductsWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsWrapper",
    componentId: "sc-0-1"
})(compare_products_styles_templateObject4(), itemFlex, productsWrapperMargin, compareMarginBottom, base/* media.mediumDown */.BC.mediumDown(compare_products_styles_templateObject1()), function(props) {
    return props.isScrollable && (0,styled_components_browser_esm.css)(compare_products_styles_templateObject2());
}, function(props) {
    return props.hasScrollSnap && (0,styled_components_browser_esm.css)(compare_products_styles_templateObject3());
});
var Overlay = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Overlay",
    componentId: "sc-0-2"
})(compare_products_styles_templateObject5());

;// CONCATENATED MODULE: ./src/areas/product-compare/components/compare-products/index.tsx
function compare_products_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function compare_products_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function compare_products_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return compare_products_arrayLikeToArray(arr);
}
function compare_products_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function compare_products_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function compare_products_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function compare_products_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function compare_products_slicedToArray(arr, i) {
    return compare_products_arrayWithHoles(arr) || compare_products_iterableToArrayLimit(arr, i) || compare_products_unsupportedIterableToArray(arr, i) || compare_products_nonIterableRest();
}
function compare_products_toConsumableArray(arr) {
    return compare_products_arrayWithoutHoles(arr) || compare_products_iterableToArray(arr) || compare_products_unsupportedIterableToArray(arr) || compare_products_nonIterableSpread();
}
function compare_products_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return compare_products_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return compare_products_arrayLikeToArray(o, minLen);
}











var compare_products_CompareProducts = function(param) {
    var category = param.category, highlightDifferences = param.highlightDifferences, contentRef = param.contentRef, outerRef = param.outerRef, position = param.position, products = param.products, relatedProducts = param.relatedProducts, setScrollPosition = param.setScrollPosition, showOverlay = param.showOverlay, showSearchInHeader = param.showSearchInHeader;
    var linkTo = (0,react.useContext)(app_context/* AppContext */.Il).linkTo;
    var isDesktop = (0,react.useContext)(viewport/* ViewportContext */.R).isDesktop;
    var history = (0,react_router_dom/* useHistory */.k6)();
    var ref = compare_products_slicedToArray((0,react.useState)(null), 2), hasSideScroll = ref[0], setHasSideScroll = ref[1];
    var update = (0,react.useCallback)(throttle_default()(function() {
        setScrollPosition(contentRef && contentRef.current ? contentRef.current.scrollLeft : 0);
    }, 300), []);
    (0,react.useEffect)(function() {
        var currentWrapper = contentRef.current;
        if (!currentWrapper) return undefined;
        currentWrapper.addEventListener("scroll", update);
        return function() {
            if (currentWrapper) {
                currentWrapper.removeEventListener("scroll", update);
            }
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0,react.useEffect)(function() {
        if (contentRef.current && outerRef.current) {
            setHasSideScroll(contentRef.current.clientWidth < contentRef.current.scrollWidth);
        }
    }, [
        contentRef,
        outerRef,
        products.length
    ]);
    var onSearchSelect = (0,react.useCallback)(function(product) {
        history.push(linkTo("productCompare", {
            category: category,
            products: compare_products_toConsumableArray(products).concat([
                product
            ])
        }));
        (0,tracking/* trackComparisonSelectionChanged */.GO)(products.length + 1, "add", "search");
    }, [
        category,
        history,
        linkTo,
        products
    ]);
    return /*#__PURE__*/ react.createElement(CompareProducts, {
        ref: outerRef
    }, showOverlay && /*#__PURE__*/ react.createElement(Overlay, null), hasSideScroll && isDesktop && /*#__PURE__*/ react.createElement(chevron_buttons, {
        contentRef: contentRef,
        position: position,
        setPosition: setScrollPosition
    }), /*#__PURE__*/ react.createElement(ProductsWrapper, {
        ref: contentRef,
        isScrollable: showSearchInHeader,
        hasScrollSnap: features.useCSSScrollSnap
    }, /*#__PURE__*/ react.createElement(columns, {
        highlightDifferences: highlightDifferences,
        products: products
    })), !showSearchInHeader && products.length < 12 ? /*#__PURE__*/ react.createElement(product_finder, {
        focusOnMount: true,
        onSelect: onSearchSelect,
        relatedProducts: relatedProducts,
        showNewComparePageLayout: true,
        showSearchInHeader: showSearchInHeader
    }) : null);
};
/* harmony default export */ const compare_products = (compare_products_CompareProducts);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/hideable/index.js
var hideable = __webpack_require__(94332);
;// CONCATENATED MODULE: ./src/components/sticky-page-header/styles.ts
function sticky_page_header_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function sticky_page_header_styles_templateObject() {
    var data = sticky_page_header_styles_taggedTemplateLiteral([
        "\n      top: ",
        ";\n    "
    ]);
    sticky_page_header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function sticky_page_header_styles_templateObject1() {
    var data = sticky_page_header_styles_taggedTemplateLiteral([
        "\n    flex-direction: column;\n    position: sticky;\n    top: ",
        ";\n    background: ",
        ";\n    z-index: 3;\n    box-shadow: 1px 3px 6px 0 rgba(0, 0, 0, 0.2);\n    padding-bottom: ",
        ";\n\n    ",
        "\n  "
    ]);
    sticky_page_header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var paddingBottom = "5px";
var StickyPageHeader = (0,styled_components_browser_esm["default"])(hideable.Hideable).withConfig({
    displayName: "StickyPageHeader",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(sticky_page_header_styles_templateObject1(), base/* layout.headerHeight.desktop.rem */.bK.headerHeight.desktop.rem, props.theme.colors.base0, paddingBottom, base/* media.smallOnly */.BC.smallOnly(sticky_page_header_styles_templateObject(), base/* layout.headerHeight.mobile.rem */.bK.headerHeight.mobile.rem));
});

;// CONCATENATED MODULE: ./src/components/sticky-page-header/index.tsx
function sticky_page_header_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function sticky_page_header_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function sticky_page_header_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function sticky_page_header_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function sticky_page_header_slicedToArray(arr, i) {
    return sticky_page_header_arrayWithHoles(arr) || sticky_page_header_iterableToArrayLimit(arr, i) || sticky_page_header_unsupportedIterableToArray(arr, i) || sticky_page_header_nonIterableRest();
}
function sticky_page_header_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return sticky_page_header_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sticky_page_header_arrayLikeToArray(o, minLen);
}


var sticky_page_header_StickyPageHeader = function(param) {
    var className = param.className, children = param.children, _scrollTopLimit = param.scrollTopLimit, scrollTopLimit = _scrollTopLimit === void 0 ? 400 : _scrollTopLimit;
    var ref = sticky_page_header_slicedToArray((0,react.useState)(scrollTopLimit === 0 || false), 2), showStickyHeader = ref[0], setShowStickyHeader = ref[1];
    var handleScroll = (0,react.useCallback)(function() {
        if (scrollTopLimit === 0) setShowStickyHeader(true);
        else if (window.scrollY <= scrollTopLimit && showStickyHeader) setShowStickyHeader(false);
        else if (window.scrollY > scrollTopLimit && !showStickyHeader) setShowStickyHeader(true);
    }, [
        scrollTopLimit,
        showStickyHeader
    ]);
    // Re-registers event listener every time the showStickyHeader state changes,
    // so the callback always gets fresh state.
    (0,react.useEffect)(function() {
        document.addEventListener("scroll", handleScroll);
        return function() {
            document.removeEventListener("scroll", handleScroll);
        };
    }, [
        handleScroll,
        showStickyHeader
    ]);
    return /*#__PURE__*/ react.createElement(StickyPageHeader, {
        className: className,
        visible: showStickyHeader
    }, children);
};

// EXTERNAL MODULE: ./src/globals/actions/index.ts
var globals_actions = __webpack_require__(46095);
// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(5148);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(30082);
// EXTERNAL MODULE: ./src/areas/product-compare/query.graphql
var query_graphql = __webpack_require__(88273);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(98854);
;// CONCATENATED MODULE: ./src/areas/product-compare/queries/useProductComparePageQuery.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


function useProductComparePageQuery(variables) {
    var productIdRelated = getProductIdRelated(variables);
    return (0,use_page_query/* usePageQuery */.v)({
        query: (query_graphql_default()),
        routeName: "productCompare",
        variables: _objectSpreadProps(_objectSpread({}, variables), {
            productIdRelated: productIdRelated
        })
    });
}
var getProductIdRelated = function(variables) {
    if (variables.productIdRelated) {
        return variables.productIdRelated;
    }
    if (Array.isArray(variables.productIds)) {
        return variables.productIds.length ? variables.productIds[0] : null;
    }
    return variables.productIds;
};

;// CONCATENATED MODULE: ./src/areas/product-compare/product-compare.tsx
function product_compare_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function product_compare_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function product_compare_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function product_compare_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_compare_slicedToArray(arr, i) {
    return product_compare_arrayWithHoles(arr) || product_compare_iterableToArrayLimit(arr, i) || product_compare_unsupportedIterableToArray(arr, i) || product_compare_nonIterableRest();
}
function product_compare_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return product_compare_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return product_compare_arrayLikeToArray(o, minLen);
}














var ProductComparePageLoader = function() {
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var ref = useProductComparePageQuery(route.variables), data = ref.data, isLoading = ref.isLoading, isSuccess = ref.isSuccess;
    if (!isLoading && !isSuccess) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true
    }, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && data ? /*#__PURE__*/ react.createElement(ProductComparePage, {
        data: data
    }) : null);
};
var Compare = function(param) {
    var adsViewUpdateDispatch = param.adsViewUpdateDispatch, data = param.data, showSearchInput = param.showSearchInput, setAddProductAnimation = param.setAddProductAnimation, toggleSearchInput = param.toggleSearchInput;
    var category = data.category, products = data.products, relatedProducts = data.relatedProducts;
    var ref = (0,react.useContext)(context/* default */.ZP), isDesktop = ref.isDesktop, isMobile = ref.isMobile;
    var initialShouldAnimate = false;
    var contentRef = (0,react.useRef)(null);
    var outerRef = (0,react.useRef)(null);
    var isProductAdded = (0,react.useRef)(initialShouldAnimate);
    var ref1 = product_compare_slicedToArray((0,react.useState)(null), 2), productCount = ref1[0], setProductCount = ref1[1];
    var ref2 = product_compare_slicedToArray((0,react.useState)(contentRef && contentRef.current ? contentRef.current.scrollLeft : 0), 2), scrollPosition = ref2[0], setScrollPosition = ref2[1];
    var ref3 = product_compare_slicedToArray((0,react.useState)(false), 2), highlightDifferences = ref3[0], setHighlightDifferences = ref3[1];
    var showSearchInHeader = !isDesktop || Boolean(products && products.length > 3);
    var showOverlay = !isDesktop && showSearchInput;
    // We use ref instead of state here because state will not be updated
    // inside event listeners, as it belongs to the initial render only.
    var setProductAdded = function(state) {
        isProductAdded.current = state;
    };
    var addProductScrollHandler = (0,react.useCallback)(debounce_default()(function() {
        if (isProductAdded.current) {
            setAddProductAnimation(true);
            setProductAdded(false);
        }
    }, 300), []);
    (0,react.useEffect)(function() {
        // Explicitly tell ads to update visibility/load (needed when lazy loading pages)
        adsViewUpdateDispatch({
            view: "productCompare:mounted"
        });
        setProductCount(products ? products.length : null);
    }, [
        adsViewUpdateDispatch,
        products
    ]);
    var productList = Array.isArray(products) ? products.filter(function(item) {
        return Boolean(item);
    }) : [];
    var scrollToEnd = (0,react.useCallback)(function() {
        if (!contentRef.current) {
            return;
        }
        var newPosition = contentRef.current.scrollWidth - contentRef.current.clientWidth;
        contentRef.current.scrollTo({
            left: newPosition,
            behavior: "smooth"
        });
        setScrollPosition(newPosition);
    }, []);
    (0,react.useEffect)(function() {
        if (!productCount || !products) return;
        if (products.length > productCount) {
            setProductAdded(true);
            scrollToEnd();
        }
    }, [
        productCount,
        products,
        scrollToEnd
    ]);
    (0,react.useEffect)(function() {
        var current = contentRef.current;
        if (current) {
            current.addEventListener("scroll", addProductScrollHandler);
        }
        return function() {
            if (current) {
                current.removeEventListener("scroll", addProductScrollHandler);
            }
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return products ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(page_header, {
        category: category,
        highlightDifferences: highlightDifferences,
        products: productList,
        relatedProducts: relatedProducts,
        setHighlightDifferences: setHighlightDifferences,
        showSearchInHeader: showSearchInHeader,
        showSearchInput: showSearchInput,
        toggleSearchInput: toggleSearchInput
    }), isMobile && Boolean(products.length) && contentRef.current && /*#__PURE__*/ react.createElement(sticky_page_header_StickyPageHeader, null, /*#__PURE__*/ react.createElement(carousel, {
        clientWidth: contentRef.current.clientWidth,
        products: productList,
        scrollPosition: scrollPosition,
        totalVisibleDots: 10,
        totalVisibleItems: 2
    })), /*#__PURE__*/ react.createElement(compare_products, {
        category: category,
        highlightDifferences: highlightDifferences,
        contentRef: contentRef,
        outerRef: outerRef,
        position: scrollPosition,
        products: productList,
        relatedProducts: relatedProducts,
        setScrollPosition: setScrollPosition,
        showOverlay: showOverlay,
        showSearchInHeader: showSearchInHeader
    })) : null;
};
var product_compare_mapStateToProps = function(state) {
    return {
        showSearchInput: state.areas.compare.showSearchInput
    };
};
var product_compare_dispatchProps = {
    adsViewUpdateDispatch: globals_actions/* adsViewUpdate */.mT,
    setAddProductAnimation: actions/* setAddProductAnimation */._6,
    toggleSearchInput: actions/* toggleSearchInput */.Ie
};
var ProductComparePage = (0,es/* connect */.$j)(product_compare_mapStateToProps, product_compare_dispatchProps)(Compare);
/* harmony default export */ const product_compare = (ProductComparePageLoader);


/***/ }),

/***/ 47963:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": () => (/* binding */ ListItem)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(102);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5741);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



var ListItem = function(param) {
    var children = param.children, name = param.name, link = param.link, image = param.image, callToActionText = param.callToActionText, showArrow = param.showArrow, showBackArrow = param.showBackArrow, _onClick = param.onClick, onClick = _onClick === void 0 ? src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT : _onClick, className = param.className, isExternal = param.isExternal, linkAttributes = param.linkAttributes, dataTest = param["data-test"], disabled = param.disabled;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .ListItem */ .HC, _extends({
        onClick: onClick,
        className: className,
        to: link,
        isExternal: isExternal
    }, linkAttributes || {}, {
        "data-test": dataTest,
        disabled: disabled
    }), showBackArrow && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .LeftArrow */ .IT, null), image && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, null, image), children, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Name */ .VG, null, name), callToActionText && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .CallToAction */ .Jd, null, callToActionText), showArrow && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RightArrow */ .UV, null));
};


/***/ }),

/***/ 5741:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": () => (/* binding */ Image),
/* harmony export */   "HC": () => (/* binding */ ListItem),
/* harmony export */   "IT": () => (/* binding */ LeftArrow),
/* harmony export */   "Jd": () => (/* binding */ CallToAction),
/* harmony export */   "UV": () => (/* binding */ RightArrow),
/* harmony export */   "VG": () => (/* binding */ Name)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var _prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98841);
/* harmony import */ var _prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26959);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38689);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(102);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      cursor: default;\n      opacity: 0.5;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  cursor: pointer;\n  min-height: 48px;\n  padding: ",
        " ",
        ";\n  text-align: left;\n  display: flex;\n  align-items: center;\n\n  /* Set the width and box-sizing to account for inconsistencies between <button> and <a> */\n  box-sizing: border-box;\n  width: 100%;\n\n  &:hover,\n  &.focus-visible {\n    background-color: ",
        ";\n    outline: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  flex: 0 1 50%;\n  margin-left: ",
        ";\n  overflow: hidden;\n  text-align: right;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  margin-left: ",
        ";\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  margin-right: ",
        ";\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var padding = src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050;
var ListItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_clickable__WEBPACK_IMPORTED_MODULE_3__/* .Clickable */ .P).withConfig({
    displayName: "ListItem",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.theme.text.primary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, padding, function(props) {
    return props.theme.bg.secondary;
}, function(props) {
    return props.disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
});
var Image = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Image",
    componentId: "sc-0-1"
})(_templateObject2(), padding);
var Name = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "Name",
    componentId: "sc-0-2"
})(_templateObject3());
var CallToAction = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "CallToAction",
    componentId: "sc-0-3"
})(_templateObject4(), function(props) {
    return props.theme.text.callToAction;
}, padding);
var RightArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__.IconChevronRight).attrs({
    size: 20
}).withConfig({
    displayName: "RightArrow",
    componentId: "sc-0-4"
})(_templateObject5(), padding);
var LeftArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__.IconChevronLeft).attrs({
    size: 20
}).withConfig({
    displayName: "LeftArrow",
    componentId: "sc-0-5"
})(_templateObject6(), padding);


/***/ }),

/***/ 8810:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mr": () => (/* reexport */ SIZE),
  "WX": () => (/* binding */ ProductCheckbox),
  "lo": () => (/* reexport */ hoverStyle)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/check/index.js
var check = __webpack_require__(44006);
;// CONCATENATED MODULE: ./src/components/product-checkbox/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  box-shadow: inset 0 0 0 2px ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  align-self: center;\n  background: ",
        ";\n  box-shadow: inset 0 0 0 1px ",
        ";\n  color: ",
        ";\n  border-radius: 3px;\n  cursor: pointer;\n  height: ",
        "px;\n  width: ",
        "px;\n  flex: 0 0 auto;\n  transition:\n    0.05s box-shadow linear,\n    0.05s background-color linear;\n\n  &:hover {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  appearance: none;\n  outline: 0;\n  opacity: 0;\n  position: absolute;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var SIZE = 20;
var hoverStyle = (0,styled_components_browser_esm.css)(_templateObject(), function(props) {
    return props.theme.bg.productCompare;
});
var Wrapper = styled_components_browser_esm["default"].label.attrs({
    "data-test": "ProductCheckbox"
}).withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.selected ? props.theme.bg.productCompare : "transparent";
}, function(props) {
    return props.theme.bg.productCompare;
}, function(props) {
    return props.theme.colors.base0;
}, SIZE, SIZE, hoverStyle);
var Input = styled_components_browser_esm["default"].input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "Input",
    componentId: "sc-0-1"
})(_templateObject2());
var Icon = (0,styled_components_browser_esm["default"])(check/* IconCheck */.N).attrs({
    size: SIZE
}).withConfig({
    displayName: "Icon",
    componentId: "sc-0-2"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/components/product-checkbox/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var ProductCheckbox = function(_param) {
    var selected = _param.selected, name = _param.name, onSelect = _param.onSelect, onDeselect = _param.onDeselect, wrapperProps = _objectWithoutProperties(_param, [
        "selected",
        "name",
        "onSelect",
        "onDeselect"
    ]);
    var onChange = (0,react.useCallback)(function(e) {
        return e.target.checked ? onSelect === null || onSelect === void 0 ? void 0 : onSelect() : onDeselect === null || onDeselect === void 0 ? void 0 : onDeselect();
    }, [
        onSelect,
        onDeselect
    ]);
    return /*#__PURE__*/ react.createElement(Wrapper, _extends({
        selected: selected
    }, wrapperProps), /*#__PURE__*/ react.createElement(Input, {
        id: name,
        name: name,
        type: "checkbox",
        checked: selected,
        onChange: onChange,
        tabIndex: 0,
        value: selected ? "1" : "0"
    }), selected && /*#__PURE__*/ react.createElement(Icon, null));
};


/***/ }),

/***/ 11037:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ product_row)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(47477);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(9160);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
// EXTERNAL MODULE: ./src/components/product-checkbox/index.tsx + 1 modules
var product_checkbox = __webpack_require__(8810);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/components/product-row/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 5px 10px;\n  outline: none;\n\n  :hover::after,\n  :focus::after {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: 1px solid ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        " {\n        padding-left: ",
        "px;\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "::before {\n        ",
        "\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  line-height: 1.2em;\n  min-height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  ",
        "\n  ",
        "\n  ",
        "\n\n  .pj-ui-product-core-properties {\n    margin: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  margin-right: 10px;\n  background: ",
        ";\n  border-radius: ",
        ";\n\n  .pj-ui-product-image {\n    display: block;\n    max-width: 40px;\n    max-height: 40px;\n    width: auto;\n    height: auto;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 100%;\n  margin-right: 3px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  :not(:last-child) {\n    margin-bottom: 1px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  margin-left: 10px;\n  white-space: nowrap;\n  text-align: right;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  font-size: 12px;\n  color: ",
        ";\n  fill: ",
        ";\n  align-items: center;\n\n  svg {\n    height: 16px !important;\n    width: 16px !important;\n    margin-left: 2px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: ",
        ";\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n\n  ",
        ":hover & {\n    ",
        "\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  min-width: 80px;\n  margin: ",
        ";\n  display: flex;\n  justify-content: end;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: -",
        ";\n  z-index: 2;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}




var ProductLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ProductLink",
    componentId: "sc-0-0"
})(_templateObject(), base/* styledUtils.overlay */.au.overlay());
var Row = styled_components_browser_esm["default"].div.attrs({
    "data-test": "ProductRow"
}).withConfig({
    displayName: "Row",
    componentId: "sc-0-1"
})(_templateObject4(), function(props) {
    return props.showDivider && (0,styled_components_browser_esm.css)(_templateObject1(), function(p) {
        return p.theme.lines.primary;
    });
}, function(props) {
    return props.selectable && (0,styled_components_browser_esm.css)(_templateObject2(), ProductLink, product_checkbox/* PRODUCT_CHECKBOX_SIZE */.mr + (0,base/* pixelCalc */.A)(base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
}, function(props) {
    return props.selected && (0,styled_components_browser_esm.css)(_templateObject3(), ProductLink, base/* styledUtils.overlay */.au.overlay(props.theme.bg.productCompareLight));
});
var ProductImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-2"
})(_templateObject5(), function(p) {
    return p.theme.colors.base200;
}, base/* layout.borderRadius */.bK.borderRadius);
var BasicInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BasicInfo",
    componentId: "sc-0-3"
})(_templateObject6());
var ProductName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductName",
    componentId: "sc-0-4"
})(_templateObject7());
var Subtitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-5"
})(_templateObject8(), function(p) {
    return p.theme.text.tertiary;
});
var PriceLabelWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "PriceLabelWrapper",
    componentId: "sc-0-6"
})(_templateObject9());
var StoreCount = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StoreCount",
    componentId: "sc-0-7"
})(_templateObject10(), function(p) {
    return p.theme.text.tertiary;
}, function(p) {
    return p.theme.icons.tertiary;
});
var Gutter = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Gutter",
    componentId: "sc-0-8"
})(_templateObject11());
var SelectBox = (0,styled_components_browser_esm["default"])(product_checkbox/* ProductCheckbox */.WX).withConfig({
    displayName: "SelectBox",
    componentId: "sc-0-9"
})(_templateObject12(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, Row, product_checkbox/* productCheckboxHoverStyle */.lo);
var CampaignBadgeWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CampaignBadgeWrapper",
    componentId: "sc-0-10"
})(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CampaignBadge = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CampaignBadge",
    componentId: "sc-0-11"
})(_templateObject14(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/shopping-cart/index.js
var shopping_cart = __webpack_require__(25117);
;// CONCATENATED MODULE: ./src/components/product-row/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}





var ProductRow = function(param) {
    var onClick = param.onClick, linkAttributes = param.linkAttributes, _link = param.link, link = _link === void 0 ? "" : _link, image = param.image, name = param.name, rating = param.rating, subtitle = param.subtitle, campaignBadge = param.campaignBadge, ratingCount = param.ratingCount, _ratingCountTranslation = param.ratingCountTranslation, ratingCountTranslation = _ratingCountTranslation === void 0 ? {
        domain: "product",
        key: "product-card.n-ratings"
    } : _ratingCountTranslation, price = param.price, storesCount = param.storesCount, storesCountText = param.storesCountText, children = param.children, className = param.className, showDivider = param.showDivider, selectable = param.selectable, selected = param.selected, onSelect = param.onSelect, onDeselect = param.onDeselect;
    var onToggle = selected ? onDeselect : onSelect;
    var clickHandler = (0,react.useCallback)(function(e) {
        if (selectable) {
            e.preventDefault();
            onToggle === null || onToggle === void 0 ? void 0 : onToggle();
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [
        selectable,
        onToggle,
        onClick
    ]);
    return /*#__PURE__*/ react.createElement(Row, {
        className: className,
        showDivider: showDivider,
        selectable: selectable,
        selected: selected
    }, /*#__PURE__*/ react.createElement(ProductLink, _extends({
        onClick: clickHandler
    }, linkAttributes || {}, {
        to: link,
        "aria-label": name
    }), image && /*#__PURE__*/ react.createElement(ProductImage, null, image), /*#__PURE__*/ react.createElement(BasicInfo, null, /*#__PURE__*/ react.createElement(ProductName, null, name), rating ? /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        hide: rating === null,
        rate: rating,
        showRate: true,
        size: "small",
        count: ratingCount,
        countTranslation: ratingCountTranslation,
        showCounter: true
    }) : null, subtitle && /*#__PURE__*/ react.createElement(Subtitle, null, subtitle)), campaignBadge && /*#__PURE__*/ react.createElement(CampaignBadgeWrapper, null, /*#__PURE__*/ react.createElement(CampaignBadge, null, campaignBadge)), price && /*#__PURE__*/ react.createElement(PriceLabelWrapper, null, /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
        value: price
    }), storesCount !== null && /*#__PURE__*/ react.createElement(StoreCount, {
        title: storesCountText
    }, /*#__PURE__*/ react.createElement("span", null, storesCount), " ", /*#__PURE__*/ react.createElement(shopping_cart/* IconShoppingCart */.w, {
        color: "base500"
    })))), children && /*#__PURE__*/ react.createElement(Gutter, null, children), selectable && /*#__PURE__*/ react.createElement(SelectBox, {
        selected: selected,
        onSelect: onSelect,
        onDeselect: onDeselect,
        "aria-label": name
    }));
};
/* harmony default export */ const product_row = (ProductRow);


/***/ }),

/***/ 5220:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ product_search)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/search/search.js + 10 modules
var search_search = __webpack_require__(68758);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(24084);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(87044);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
// EXTERNAL MODULE: ./src/components/product-row/index.tsx + 1 modules
var product_row = __webpack_require__(11037);
;// CONCATENATED MODULE: ./src/components/product-search/components/related-products/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 4;\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n          top: 37px;\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n      top: 47px;\n\n      ",
        ", ",
        " {\n        padding: 0 ",
        ";\n      }\n\n      ",
        "\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    background: ",
        ";\n    border-radius: 4px;\n    width: 100%;\n\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n          padding: 0 ",
        ";\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    min-height: auto;\n\n    ",
        "\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var relatedProductsTitleFontSize = (0,base/* remCalc */.vR)(15);
var boxShadowStyle = "0px 6px 10px 0px rgba(0, 0, 0, 0.2)";
var relatedProductsOverlayStyles = (0,styled_components_browser_esm.css)(_templateObject(), boxShadowStyle);
var RelatedProductsTitle = styled_components_browser_esm["default"].h5.withConfig({
    displayName: "RelatedProductsTitle",
    componentId: "sc-0-0"
})(_templateObject1(), relatedProductsTitleFontSize, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var RelatedProductsSubTitle = styled_components_browser_esm["default"].p.withConfig({
    displayName: "RelatedProductsSubTitle",
    componentId: "sc-0-1"
})(_templateObject2(), function(p) {
    return p.theme.text.quaternary;
});
var RelatedProducts = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RelatedProducts",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject5(), props.theme.colors.base0, props.relatedProductsAsOverlay && (0,styled_components_browser_esm.css)(_templateObject4(), relatedProductsOverlayStyles, RelatedProductsTitle, RelatedProductsSubTitle, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject3())));
});
var ProductRow = (0,styled_components_browser_esm["default"])(product_row/* default */.Z).withConfig({
    displayName: "ProductRow",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject8(), props.showNewComparePageLayout && (0,styled_components_browser_esm.css)(_templateObject7(), base/* media.mediumDown */.BC.mediumDown(_templateObject6(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100)));
});

;// CONCATENATED MODULE: ./src/components/product-search/components/related-products/index.tsx




var related_products_RelatedProducts = function(param) {
    var relatedProducts = param.relatedProducts, relatedProductsAsOverlay = param.relatedProductsAsOverlay, onSelect = param.onSelect, showNewComparePageLayout = param.showNewComparePageLayout;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(RelatedProducts, {
        relatedProductsAsOverlay: relatedProductsAsOverlay
    }, /*#__PURE__*/ react.createElement(RelatedProductsTitle, null, t("product", "recommendations.similar-products")), /*#__PURE__*/ react.createElement(RelatedProductsSubTitle, null, t("compare", "related-products.add")), relatedProducts.map(function(relatedProduct) {
        var onClickHandler = function(e) {
            e.preventDefault();
            onSelect(relatedProduct);
        };
        return /*#__PURE__*/ react.createElement(ProductRow, {
            key: "related-product-".concat(relatedProduct.id),
            onClick: onClickHandler,
            name: relatedProduct.name,
            price: relatedProduct.price,
            image: relatedProduct.imageUrl && /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                name: relatedProduct.name,
                src: relatedProduct.imageUrl
            }),
            showDivider: true,
            showNewComparePageLayout: showNewComparePageLayout
        });
    }));
};
/* harmony default export */ const related_products = (related_products_RelatedProducts);

;// CONCATENATED MODULE: ./src/components/product-search/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n      border-bottom: none;\n      border-radius: 5px 5px 0px 0px;\n    "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    border: ",
        "px solid\n      ",
        ";\n    overflow: hidden;\n    border-bottom: ",
        "px solid\n      ",
        ";\n    border-radius: 5px;\n\n    ",
        "\n  "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n        border: 1px solid ",
        ";\n        border-top: none;\n      "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n          top: ",
        ";\n        "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n          top: ",
        "px;\n        "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n          top: ",
        "px;\n        "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n      position: absolute;\n      left: 0;\n      right: 0;\n      border: none;\n      border-top: none;\n      z-index: 10;\n      box-shadow: ",
        ";\n\n      ",
        "\n\n      ",
        ";\n\n      ",
        ";\n\n      ",
        ";\n    "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n      padding: 0 ",
        ";\n    "
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n    position: relative;\n    background: ",
        ";\n    border-radius: 0px 0px 5px 5px;\n    overflow: hidden;\n    text-align: left;\n\n    ",
        ";\n\n    .pj-ui-search--products {\n      padding-top: 0;\n    }\n\n    ",
        ";\n  "
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n          padding: 0 ",
        ";\n\n          ",
        " {\n            border-bottom: 1px solid ",
        ";\n            border-radius: 5px;\n          }\n\n          ",
        " {\n            border: none;\n            box-shadow: none;\n          }\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n    width: 100%;\n\n    ",
        "\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


var searchHeight = base/* layout.searchBar.height.desktop.value */.bK.searchBar.height.desktop.value;
var searchHeightMobile = base/* layout.searchBar.height.mobile.value */.bK.searchBar.height.mobile.value;
var searchBorderWidth = base/* layout.searchBar.borderWidth */.bK.searchBar.borderWidth;
var styles_boxShadowStyle = "0px 6px 10px 0px rgba(0, 0, 0, 0.2)";
var SearchInput = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchInput",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(styles_templateObject1(), base/* layout.searchBar.borderWidth */.bK.searchBar.borderWidth, function(p) {
        return p.theme.colors.maybeBlue700;
    }, base/* layout.searchBar.borderWidth */.bK.searchBar.borderWidth, function(p) {
        return p.theme.colors.maybeBlue700;
    }, props.searchIsOpen && (0,styled_components_browser_esm.css)(styles_templateObject()));
});
var SearchResult = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchResult",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(styles_templateObject8(), props.theme.colors.base0, props.showFloatingResult && (0,styled_components_browser_esm.css)(styles_templateObject6(), styles_boxShadowStyle, props.searchIsOpen && (0,styled_components_browser_esm.css)(styles_templateObject2(), props.theme.colors.maybeBlue700), base/* media.smallOnly */.BC.smallOnly(styles_templateObject3(), props.showNewComparePageLayout ? "".concat(searchHeightMobile + searchBorderWidth * 2, "px") : "".concat(searchHeightMobile, "px")), base/* media.mediumOnly */.BC.mediumOnly(styles_templateObject4(), searchHeight + searchBorderWidth * 2), base/* media.largeUp */.BC.largeUp(styles_templateObject5(), searchHeight)), base/* media.mediumDown */.BC.mediumDown(styles_templateObject7(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
});
var SearchWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchWrapper",
    componentId: "sc-0-2"
})(_templateObject9());
var Search = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Search",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject12(), props.showNewComparePageLayout && (0,styled_components_browser_esm.css)(_templateObject11(), base/* media.mediumDown */.BC.mediumDown(_templateObject10(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, SearchInput, props.theme.colors.maybeBlue700, SearchResult)));
});

;// CONCATENATED MODULE: ./src/components/product-search/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var INPUT_MIN_LENGTH = 2;
var SEARCH_OPTIONS = {
    groups: [
        {
            limit: 5,
            name: "products",
            modes: [
                "product"
            ]
        }
    ]
};
var ProductSearch = function(param) {
    var _showNewComparePageLayout = param.showNewComparePageLayout, showNewComparePageLayout = _showNewComparePageLayout === void 0 ? false : _showNewComparePageLayout, _relatedProductsAsOverlay = param.relatedProductsAsOverlay, relatedProductsAsOverlay = _relatedProductsAsOverlay === void 0 ? false : _relatedProductsAsOverlay, _showFloatingResult = param.showFloatingResult, showFloatingResult = _showFloatingResult === void 0 ? true : _showFloatingResult, focusOnMount = param.focusOnMount, placeholder = param.placeholder, onSelect = param.onSelect, relatedProducts = param.relatedProducts;
    var searchRef = (0,react.useRef)(null);
    var searchInputRef = (0,react.useRef)(null);
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = _slicedToArray((0,react.useState)(""), 2), inputValue = ref[0], setInputValueState = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(""), 2), search = ref1[0], setSearchState = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(false), 2), hasResultsState = ref2[0], setHasResultsState = ref2[1];
    var ref3 = _slicedToArray((0,react.useState)([]), 2), results = ref3[0], setResultsState = ref3[1];
    var resetSearch = function() {
        setSearchState("");
        setHasResultsState(false);
    };
    var handleOnChange = (0,react.useCallback)(function(searchTerm) {
        setSearchState(searchTerm);
        setHasResultsState(false);
    }, []);
    var handleOnFocus = (0,react.useCallback)(function(searchTerm) {
        if (searchTerm.length >= INPUT_MIN_LENGTH) {
            setSearchState(searchTerm);
            setHasResultsState(true);
        }
    }, []);
    var setInputValue = (0,react.useCallback)(function(input) {
        setInputValueState(input);
    }, []);
    var handleOnSelect = (0,react.useCallback)(function(product) {
        setInputValueState("");
        resetSearch();
        return onSelect(product);
    }, [
        onSelect
    ]);
    var handleSearchResultFound = (0,react.useCallback)(function() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        var ref;
        setHasResultsState(true);
        var ref1;
        setResultsState((ref1 = (ref = items[0]) === null || ref === void 0 ? void 0 : ref.hits) !== null && ref1 !== void 0 ? ref1 : []);
    }, []);
    var handleKeyDown = (0,react.useCallback)(function(e) {
        if (e.key === "Escape") {
            resetSearch();
        }
    }, []);
    var handleClickOutside = (0,react.useCallback)(function(e) {
        if (e.target && searchRef.current && !searchRef.current.contains(e.target)) {
            resetSearch();
        }
    }, []);
    (0,react.useEffect)(function() {
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("click", handleClickOutside);
        if (focusOnMount && searchInputRef.current) {
            var inputElement = searchInputRef.current.querySelector("input[type=text]");
            if (inputElement) {
                inputElement.focus();
            }
        }
        return function() {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("click", handleClickOutside);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var searchIsOpen = inputValue.length >= INPUT_MIN_LENGTH && search !== "";
    var hasResults = hasResultsState && search !== "" && results && results.length > 0;
    return /*#__PURE__*/ react.createElement(SearchWrapper, {
        ref: searchRef
    }, /*#__PURE__*/ react.createElement(Search, {
        showNewComparePageLayout: showNewComparePageLayout
    }, /*#__PURE__*/ react.createElement(SearchInput, {
        ref: searchInputRef,
        searchIsOpen: searchIsOpen
    }, /*#__PURE__*/ react.createElement(inputs/* Search */.ol, {
        key: "search",
        placeholder: placeholder || t("search", "search-products.placeholder"),
        hasResults: hasResults,
        onChange: handleOnChange,
        onFocus: handleOnFocus,
        inputValue: inputValue,
        setInputValue: setInputValue
    })), /*#__PURE__*/ react.createElement(SearchResult, {
        searchIsOpen: searchIsOpen,
        showFloatingResult: showFloatingResult,
        showNewComparePageLayout: showNewComparePageLayout
    }, /*#__PURE__*/ react.createElement(search_search/* default */.Z, {
        query: search,
        onSelect: handleOnSelect,
        showAllResults: false,
        keyboardNavigation: false,
        styling: "none",
        disableScrollToTop: true,
        onSearchResultFound: handleSearchResultFound,
        options: SEARCH_OPTIONS,
        inputMinLength: INPUT_MIN_LENGTH
    }))), relatedProducts && Boolean(relatedProducts.length) && !hasResults && Boolean(!searchIsOpen) && /*#__PURE__*/ react.createElement(related_products, {
        relatedProducts: relatedProducts,
        relatedProductsAsOverlay: relatedProductsAsOverlay,
        onSelect: onSelect,
        showNewComparePageLayout: showNewComparePageLayout
    }));
};
/* harmony default export */ const product_search = (ProductSearch);


/***/ }),

/***/ 81678:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": () => (/* binding */ Truncated)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  /* stylelint-disable */\n  /* Restrict the box to the specified number of lines of text.\n   * See https://css-tricks.com/almanac/properties/l/line-clamp/ */\n  display: -webkit-box;\n  -webkit-line-clamp: ",
        ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var _maxLines;
var Truncated = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Truncated",
    componentId: "sc-0-0"
})(_templateObject(), function(props) {
    return (_maxLines = props.maxLines) !== null && _maxLines !== void 0 ? _maxLines : 2;
});


/***/ })

}]);